"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4285],{

/***/ 46797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KR": function() { return /* binding */ R; }
/* harmony export */ });
/* unused harmony exports Carousel, Panzoom */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43190);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32977);
/* harmony import */ var _swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13229);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4012);
/* harmony import */ var _swc_helpers_src_possible_constructor_return_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1892);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34817);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37731);
// @fancyapps/ui/Fancybox v4.0.31













var t = function(t) {
    return "object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t);
}, e = function() {
    for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
        i[_key] = arguments[_key];
    }
    var s = !1;
    "boolean" == typeof i[0] && (s = i.shift());
    var o = i[0];
    if (!o || "object" != typeof o) throw new Error("extendee must be an object");
    var n = i.slice(1), a = n.length;
    for(var i1 = 0; i1 < a; i1++){
        var a1 = n[i1];
        for(var i2 in a1)if (a1.hasOwnProperty(i2)) {
            var n1 = a1[i2];
            if (s && (Array.isArray(n1) || t(n1))) {
                var t1 = Array.isArray(n1) ? [] : {};
                o[i2] = e(!0, o.hasOwnProperty(i2) ? o[i2] : t1, n1);
            } else o[i2] = n1;
        }
    }
    return o;
}, i = function(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e4;
    return t = parseFloat(t) || 0, Math.round((t + Number.EPSILON) * e) / e;
}, s = function(t) {
    return !!(t && "object" == typeof t && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, Element) && t !== document.body) && !t.__Panzoom && (function(t) {
        var e = getComputedStyle(t)["overflow-y"], i = getComputedStyle(t)["overflow-x"], s = ("scroll" === e || "auto" === e) && Math.abs(t.scrollHeight - t.clientHeight) > 1, o = ("scroll" === i || "auto" === i) && Math.abs(t.scrollWidth - t.clientWidth) > 1;
        return s || o;
    }(t) ? t : s(t.parentNode));
}, o =  true && window.ResizeObserver || /*#__PURE__*/ function() {
    "use strict";
    function _class(t) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, _class);
        this.observables = [], this.boundCheck = this.check.bind(this), this.boundCheck(), this.callback = t;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_class, [
        {
            key: "observe",
            value: function observe(t) {
                if (this.observables.some(function(e) {
                    return e.el === t;
                })) return;
                var e = {
                    el: t,
                    size: {
                        height: t.clientHeight,
                        width: t.clientWidth
                    }
                };
                this.observables.push(e);
            }
        },
        {
            key: "unobserve",
            value: function unobserve(t) {
                this.observables = this.observables.filter(function(e) {
                    return e.el !== t;
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.observables = [];
            }
        },
        {
            key: "check",
            value: function check() {
                var t = this.observables.filter(function(t) {
                    var e = t.el.clientHeight, i = t.el.clientWidth;
                    if (t.size.height !== e || t.size.width !== i) return t.size.height = e, t.size.width = i, !0;
                }).map(function(t) {
                    return t.el;
                });
                t.length > 0 && this.callback(t), window.requestAnimationFrame(this.boundCheck);
            }
        }
    ]);
    return _class;
}();
var n = function n(t) {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, n);
    this.id = self.Touch && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, Touch) ? t.identifier : -1, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY;
};
var a = function(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}, r = function(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
};
var h = /*#__PURE__*/ function() {
    "use strict";
    function h(t) {
        var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = ref.start, e = tmp === void 0 ? function() {
            return !0;
        } : tmp, tmp1 = ref.move, i = tmp1 === void 0 ? function() {} : tmp1, tmp2 = ref.end, s = tmp2 === void 0 ? function() {} : tmp2;
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, h);
        this._element = t, this.startPointers = [], this.currentPointers = [], this._pointerStart = function(t) {
            if (t.buttons > 0 && 0 !== t.button) return;
            var e = new n(t);
            _this.currentPointers.some(function(t) {
                return t.id === e.id;
            }) || _this._triggerPointerStart(e, t) && (window.addEventListener("mousemove", _this._move), window.addEventListener("mouseup", _this._pointerEnd));
        }, this._touchStart = function(t) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Array.from(t.changedTouches || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var e = _step.value;
                    _this._triggerPointerStart(new n(e), t);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }, this._move = function(t) {
            var e = _this.currentPointers.slice(), i = function(t) {
                return "changedTouches" in t;
            }(t) ? Array.from(t.changedTouches).map(function(t) {
                return new n(t);
            }) : [
                new n(t)
            ];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var _$t = _step.value;
                    var e = _this.currentPointers.findIndex(function(e) {
                        return e.id === _$t.id;
                    });
                    e < 0 || (_this.currentPointers[e] = _$t);
                };
                for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            _this._moveCallback(e, _this.currentPointers.slice(), t);
        }, this._triggerPointerEnd = function(t, e) {
            var i = _this.currentPointers.findIndex(function(e) {
                return e.id === t.id;
            });
            return !(i < 0) && (_this.currentPointers.splice(i, 1), _this.startPointers.splice(i, 1), _this._endCallback(t, e), !0);
        }, this._pointerEnd = function(t) {
            t.buttons > 0 && 0 !== t.button || _this._triggerPointerEnd(new n(t), t) && (window.removeEventListener("mousemove", _this._move, {
                passive: !1
            }), window.removeEventListener("mouseup", _this._pointerEnd, {
                passive: !1
            }));
        }, this._touchEnd = function(t) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Array.from(t.changedTouches || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var e = _step.value;
                    _this._triggerPointerEnd(new n(e), t);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }, this._startCallback = e, this._moveCallback = i, this._endCallback = s, this._element.addEventListener("mousedown", this._pointerStart, {
            passive: !1
        }), this._element.addEventListener("touchstart", this._touchStart, {
            passive: !1
        }), this._element.addEventListener("touchmove", this._move, {
            passive: !1
        }), this._element.addEventListener("touchend", this._touchEnd), this._element.addEventListener("touchcancel", this._touchEnd);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(h, [
        {
            key: "stop",
            value: function stop() {
                this._element.removeEventListener("mousedown", this._pointerStart, {
                    passive: !1
                }), this._element.removeEventListener("touchstart", this._touchStart, {
                    passive: !1
                }), this._element.removeEventListener("touchmove", this._move, {
                    passive: !1
                }), this._element.removeEventListener("touchend", this._touchEnd), this._element.removeEventListener("touchcancel", this._touchEnd), window.removeEventListener("mousemove", this._move), window.removeEventListener("mouseup", this._pointerEnd);
            }
        },
        {
            key: "_triggerPointerStart",
            value: function _triggerPointerStart(t, e) {
                return !!this._startCallback(t, e) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
            }
        }
    ]);
    return h;
}();
var l = /*#__PURE__*/ function() {
    "use strict";
    function l() {
        var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, l);
        this.options = e(!0, {}, t), this.plugins = [], this.events = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        for(var _i = 0, _iter = [
            "on",
            "once"
        ]; _i < _iter.length; _i++){
            var t1 = _iter[_i];
            try {
                for(var _iterator = Object.entries(this.options[t1] || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var e1 = _step.value;
                    this[t1].apply(this, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e1));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(l, [
        {
            key: "option",
            value: function option(t, e) {
                for(var _len = arguments.length, i = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    i[_key - 2] = arguments[_key];
                }
                var _s;
                t = String(t);
                var s = (o = t, n = this.options, o.split(".").reduce(function(t, e) {
                    return t && t[e];
                }, n));
                var o, n;
                return "function" == typeof s && (s = (_s = s).call.apply(_s, [
                    this,
                    this
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(i)))), void 0 === s ? e : s;
            }
        },
        {
            key: "localize",
            value: function localize(t) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var _this = this;
                return t = (t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, function(t, i, s) {
                    var o = "";
                    s ? o = _this.option("".concat(i[0] + i.toLowerCase().substring(1), ".l10n.").concat(s)) : i && (o = _this.option("l10n.".concat(i))), o || (o = t);
                    for(var _$t = 0; _$t < e.length; _$t++)o = o.split(e[_$t][0]).join(e[_$t][1]);
                    return o;
                })).replace(/\{\{(.*)\}\}/, function(t, e) {
                    return e;
                });
            }
        },
        {
            key: "on",
            value: function on(e, i) {
                var _this = this;
                if (t(e)) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t1 = _step.value;
                            this.on.apply(this, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(t1));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return this;
                }
                return String(e).split(" ").forEach(function(t) {
                    var _$e = _this.events[t] = _this.events[t] || [];
                    -1 == _$e.indexOf(i) && _$e.push(i);
                }), this;
            }
        },
        {
            key: "once",
            value: function once(e, i) {
                var _this = this;
                if (t(e)) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t1 = _step.value;
                            this.once.apply(this, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(t1));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return this;
                }
                return String(e).split(" ").forEach(function(t) {
                    var _$e = function() {
                        for(var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++){
                            s[_key] = arguments[_key];
                        }
                        var _i;
                        _this.off(t, _$e), (_i = i).call.apply(_i, [
                            _this,
                            _this
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(s)));
                    };
                    _$e._ = i, _this.on(t, _$e);
                }), this;
            }
        },
        {
            key: "off",
            value: function off(e, i) {
                var _this = this;
                if (!t(e)) return e.split(" ").forEach(function(t) {
                    var _$e = _this.events[t];
                    if (!_$e || !_$e.length) return _this;
                    var s = -1;
                    for(var _$t = 0, o = _$e.length; _$t < o; _$t++){
                        var o1 = _$e[_$t];
                        if (o1 && (o1 === i || o1._ === i)) {
                            s = _$t;
                            break;
                        }
                    }
                    -1 != s && _$e.splice(s, 1);
                }), this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t1 = _step.value;
                        this.off.apply(this, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(t1));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "trigger",
            value: function trigger(t) {
                for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    e[_key - 1] = arguments[_key];
                }
                var _i, _i1;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this.events[t] || []).slice()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if (i && !1 === (_i = i).call.apply(_i, [
                            this,
                            this
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e)))) return !1;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this.events["*"] || []).slice()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var i1 = _step1.value;
                        if (i1 && !1 === (_i1 = i1).call.apply(_i1, [
                            this,
                            t,
                            this
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e)))) return !1;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return !0;
            }
        },
        {
            key: "attachPlugins",
            value: function attachPlugins(t) {
                var i = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(t || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_step.value, 2), s = _value[0], o = _value[1];
                        !1 === this.options[s] || this.plugins[s] || (this.options[s] = e({}, o.defaults || {}, this.options[s]), i[s] = new o(this));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = Object.entries(i)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _value1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_step1.value, 2), _$t = _value1[0], e1 = _value1[1];
                        e1.attach(this);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return this.plugins = Object.assign({}, this.plugins, i), this;
            }
        },
        {
            key: "detachPlugins",
            value: function detachPlugins() {
                for(var t in this.plugins){
                    var e = void 0;
                    (e = this.plugins[t]) && "function" == typeof e.detach && e.detach(this);
                }
                return this.plugins = {}, this;
            }
        }
    ]);
    return l;
}();
var c = {
    touch: !0,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: !1,
    lockAxis: !1,
    friction: .64,
    decelFriction: .88,
    zoomFriction: .74,
    bounceForce: .2,
    baseScale: 1,
    minScale: 1,
    maxScale: 2,
    step: .5,
    textSelection: !1,
    click: "toggleZoom",
    wheel: "zoom",
    wheelFactor: 42,
    wheelLimit: 5,
    draggableClass: "is-draggable",
    draggingClass: "is-dragging",
    ratio: 1
};
var d = /*#__PURE__*/ function(l) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(d, l);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(d);
    function d(t) {
        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, d);
        var _this;
        _this = _super.call(this, e(!0, {}, c, i)), _this.state = "init", _this.$container = t;
        for(var _i = 0, _iter = [
            "onLoad",
            "onWheel",
            "onClick"
        ]; _i < _iter.length; _i++){
            var _$t = _iter[_i];
            _this[_$t] = _this[_$t].bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this));
        }
        _this.initLayout(), _this.resetValues(), _this.attachPlugins(d.Plugins), _this.trigger("init"), _this.updateMetrics(), _this.attachEvents(), _this.trigger("ready"), !1 === _this.option("centerOnStart") ? _this.state = "ready" : _this.panTo({
            friction: 0
        }), t.__Panzoom = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this);
        return (0,_swc_helpers_src_possible_constructor_return_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(d, [
        {
            key: "initLayout",
            value: function initLayout() {
                var _i;
                var t = this.$container;
                if (!(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, HTMLElement)) throw new Error("Panzoom: Container not found");
                var e = this.option("content") || t.querySelector(".panzoom__content");
                if (!e) throw new Error("Panzoom: Content not found");
                this.$content = e;
                var i = this.option("viewport") || t.querySelector(".panzoom__viewport");
                i || !1 === this.option("wrapInner") || (i = document.createElement("div"), i.classList.add("panzoom__viewport"), (_i = i).append.apply(_i, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(t.childNodes)), t.appendChild(i)), this.$viewport = i || e.parentNode;
            }
        },
        {
            key: "resetValues",
            value: function resetValues() {
                this.updateRate = this.option("updateRate", /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 250 : 24), this.container = {
                    width: 0,
                    height: 0
                }, this.viewport = {
                    width: 0,
                    height: 0
                }, this.content = {
                    origWidth: 0,
                    origHeight: 0,
                    width: 0,
                    height: 0,
                    x: this.option("x", 0),
                    y: this.option("y", 0),
                    scale: this.option("baseScale")
                }, this.transform = {
                    x: 0,
                    y: 0,
                    scale: 1
                }, this.resetDragPosition();
            }
        },
        {
            key: "onLoad",
            value: function onLoad(t) {
                this.updateMetrics(), this.panTo({
                    scale: this.option("baseScale"),
                    friction: 0
                }), this.trigger("load", t);
            }
        },
        {
            key: "onClick",
            value: function onClick(t) {
                if (t.defaultPrevented) return;
                if (document.activeElement && document.activeElement.closest("[contenteditable]")) return;
                if (this.option("textSelection") && window.getSelection().toString().length && (!t.target || !t.target.hasAttribute("data-fancybox-close"))) return void t.stopPropagation();
                var e = this.$content.getClientRects()[0];
                if ("ready" !== this.state && (this.dragPosition.midPoint || Math.abs(e.top - this.dragStart.rect.top) > 1 || Math.abs(e.left - this.dragStart.rect.left) > 1)) return t.preventDefault(), void t.stopPropagation();
                !1 !== this.trigger("click", t) && this.option("zoom") && "toggleZoom" === this.option("click") && (t.preventDefault(), t.stopPropagation(), this.zoomWithClick(t));
            }
        },
        {
            key: "onWheel",
            value: function onWheel(t) {
                !1 !== this.trigger("wheel", t) && this.option("zoom") && this.option("wheel") && this.zoomWithWheel(t);
            }
        },
        {
            key: "zoomWithWheel",
            value: function zoomWithWheel(t) {
                void 0 === this.changedDelta && (this.changedDelta = 0);
                var e = Math.max(-1, Math.min(1, -t.deltaY || -t.deltaX || t.wheelDelta || -t.detail)), i = this.content.scale;
                var s = i * (100 + e * this.option("wheelFactor")) / 100;
                if (e < 0 && Math.abs(i - this.option("minScale")) < .01 || e > 0 && Math.abs(i - this.option("maxScale")) < .01 ? (this.changedDelta += Math.abs(e), s = i) : (this.changedDelta = 0, s = Math.max(Math.min(s, this.option("maxScale")), this.option("minScale"))), this.changedDelta > this.option("wheelLimit")) return;
                if (t.preventDefault(), s === i) return;
                var o = this.$content.getBoundingClientRect(), n = t.clientX - o.left, a = t.clientY - o.top;
                this.zoomTo(s, {
                    x: n,
                    y: a
                });
            }
        },
        {
            key: "zoomWithClick",
            value: function zoomWithClick(t) {
                var e = this.$content.getClientRects()[0], i = t.clientX - e.left, s = t.clientY - e.top;
                this.toggleZoom({
                    x: i,
                    y: s
                });
            }
        },
        {
            key: "attachEvents",
            value: function attachEvents() {
                var _this = this;
                this.$content.addEventListener("load", this.onLoad), this.$container.addEventListener("wheel", this.onWheel, {
                    passive: !1
                }), this.$container.addEventListener("click", this.onClick, {
                    passive: !1
                }), this.initObserver();
                var t = new h(this.$container, {
                    start: function(e, i) {
                        if (!_this.option("touch")) return !1;
                        if (_this.velocity.scale < 0) return !1;
                        var o = i.composedPath()[0];
                        if (!t.currentPointers.length) {
                            if (-1 !== [
                                "BUTTON",
                                "TEXTAREA",
                                "OPTION",
                                "INPUT",
                                "SELECT",
                                "VIDEO"
                            ].indexOf(o.nodeName)) return !1;
                            if (_this.option("textSelection") && function(t, e, i) {
                                var s = t.childNodes, o = document.createRange();
                                for(var _$t = 0; _$t < s.length; _$t++){
                                    var n = s[_$t];
                                    if (n.nodeType !== Node.TEXT_NODE) continue;
                                    o.selectNodeContents(n);
                                    var a = o.getBoundingClientRect();
                                    if (e >= a.left && i >= a.top && e <= a.right && i <= a.bottom) return n;
                                }
                                return !1;
                            }(o, e.clientX, e.clientY)) return !1;
                        }
                        return !s(o) && !1 !== _this.trigger("touchStart", i) && ("mousedown" === i.type && i.preventDefault(), _this.state = "pointerdown", _this.resetDragPosition(), _this.dragPosition.midPoint = null, _this.dragPosition.time = Date.now(), !0);
                    },
                    move: function(e, i, s) {
                        if ("pointerdown" !== _this.state) return;
                        if (!1 === _this.trigger("touchMove", s)) return void s.preventDefault();
                        if (i.length < 2 && !0 === _this.option("panOnlyZoomed") && _this.content.width <= _this.viewport.width && _this.content.height <= _this.viewport.height && _this.transform.scale <= _this.option("baseScale")) return;
                        if (i.length > 1 && (!_this.option("zoom") || !1 === _this.option("pinchToZoom"))) return;
                        var o = r(e[0], e[1]), n = r(i[0], i[1]), h = n.clientX - o.clientX, _$l = n.clientY - o.clientY, c = a(e[0], e[1]), _$d = a(i[0], i[1]), u = c && _$d ? _$d / c : 1;
                        _this.dragOffset.x += h, _this.dragOffset.y += _$l, _this.dragOffset.scale *= u, _this.dragOffset.time = Date.now() - _this.dragPosition.time;
                        var f = 1 === _this.dragStart.scale && _this.option("lockAxis");
                        if (f && !_this.lockAxis) {
                            if (Math.abs(_this.dragOffset.x) < 6 && Math.abs(_this.dragOffset.y) < 6) return void s.preventDefault();
                            var t1 = Math.abs(180 * Math.atan2(_this.dragOffset.y, _this.dragOffset.x) / Math.PI);
                            _this.lockAxis = t1 > 45 && t1 < 135 ? "y" : "x";
                        }
                        if ("xy" === f || "y" !== _this.lockAxis) {
                            if (s.preventDefault(), s.stopPropagation(), s.stopImmediatePropagation(), _this.lockAxis && (_this.dragOffset["x" === _this.lockAxis ? "y" : "x"] = 0), _this.$container.classList.add(_this.option("draggingClass")), _this.transform.scale === _this.option("baseScale") && "y" === _this.lockAxis || (_this.dragPosition.x = _this.dragStart.x + _this.dragOffset.x), _this.transform.scale === _this.option("baseScale") && "x" === _this.lockAxis || (_this.dragPosition.y = _this.dragStart.y + _this.dragOffset.y), _this.dragPosition.scale = _this.dragStart.scale * _this.dragOffset.scale, i.length > 1) {
                                var _$e = r(t.startPointers[0], t.startPointers[1]), _$i = _$e.clientX - _this.dragStart.rect.x, _$s = _$e.clientY - _this.dragStart.rect.y, ref = _this.getZoomDelta(_this.content.scale * _this.dragOffset.scale, _$i, _$s), o1 = ref.deltaX, a1 = ref.deltaY;
                                _this.dragPosition.x -= o1, _this.dragPosition.y -= a1, _this.dragPosition.midPoint = n;
                            } else _this.setDragResistance();
                            _this.transform = {
                                x: _this.dragPosition.x,
                                y: _this.dragPosition.y,
                                scale: _this.dragPosition.scale
                            }, _this.startAnimation();
                        }
                    },
                    end: function(e, i) {
                        if ("pointerdown" !== _this.state) return;
                        if (_this._dragOffset = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, _this.dragOffset), t.currentPointers.length) return void _this.resetDragPosition();
                        if (_this.state = "decel", _this.friction = _this.option("decelFriction"), _this.recalculateTransform(), _this.$container.classList.remove(_this.option("draggingClass")), !1 === _this.trigger("touchEnd", i)) return;
                        if ("decel" !== _this.state) return;
                        var s = _this.option("minScale");
                        if (_this.transform.scale < s) return void _this.zoomTo(s, {
                            friction: .64
                        });
                        var o = _this.option("maxScale");
                        if (_this.transform.scale - o > .01) {
                            var t1 = _this.dragPosition.midPoint || e, _$i = _this.$content.getClientRects()[0];
                            _this.zoomTo(o, {
                                friction: .64,
                                x: t1.clientX - _$i.left,
                                y: t1.clientY - _$i.top
                            });
                        } else ;
                    }
                });
                this.pointerTracker = t;
            }
        },
        {
            key: "initObserver",
            value: function initObserver() {
                var _this = this;
                this.resizeObserver || (this.resizeObserver = new o(function() {
                    _this.updateTimer || (_this.updateTimer = setTimeout(function() {
                        var t = _this.$container.getBoundingClientRect();
                        t.width && t.height ? ((Math.abs(t.width - _this.container.width) > 1 || Math.abs(t.height - _this.container.height) > 1) && (_this.isAnimating() && _this.endAnimation(!0), _this.updateMetrics(), _this.panTo({
                            x: _this.content.x,
                            y: _this.content.y,
                            scale: _this.option("baseScale"),
                            friction: 0
                        })), _this.updateTimer = null) : _this.updateTimer = null;
                    }, _this.updateRate));
                }), this.resizeObserver.observe(this.$container));
            }
        },
        {
            key: "resetDragPosition",
            value: function resetDragPosition() {
                this.lockAxis = null, this.friction = this.option("friction"), this.velocity = {
                    x: 0,
                    y: 0,
                    scale: 0
                };
                var _content = this.content, t = _content.x, e = _content.y, i = _content.scale;
                this.dragStart = {
                    rect: this.$content.getBoundingClientRect(),
                    x: t,
                    y: e,
                    scale: i
                }, this.dragPosition = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.dragPosition), {
                    x: t,
                    y: e,
                    scale: i
                }), this.dragOffset = {
                    x: 0,
                    y: 0,
                    scale: 1,
                    time: 0
                };
            }
        },
        {
            key: "updateMetrics",
            value: function updateMetrics(t) {
                !0 !== t && this.trigger("beforeUpdate");
                var e = this.$container, s = this.$content, o = this.$viewport, n = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(s, HTMLImageElement), a = this.option("zoom"), r = this.option("resizeParent", a);
                var h = this.option("width"), _$l = this.option("height"), c = h || (_$d = s, Math.max(parseFloat(_$d.naturalWidth || 0), parseFloat(_$d.width && _$d.width.baseVal && _$d.width.baseVal.value || 0), parseFloat(_$d.offsetWidth || 0), parseFloat(_$d.scrollWidth || 0)));
                var _$d;
                var u = _$l || function(t) {
                    return Math.max(parseFloat(t.naturalHeight || 0), parseFloat(t.height && t.height.baseVal && t.height.baseVal.value || 0), parseFloat(t.offsetHeight || 0), parseFloat(t.scrollHeight || 0));
                }(s);
                Object.assign(s.style, {
                    width: h ? "".concat(h, "px") : "",
                    height: _$l ? "".concat(_$l, "px") : "",
                    maxWidth: "",
                    maxHeight: ""
                }), r && Object.assign(o.style, {
                    width: "",
                    height: ""
                });
                var f = this.option("ratio");
                c = i(c * f), u = i(u * f), h = c, _$l = u;
                var g = s.getBoundingClientRect(), p = o.getBoundingClientRect(), m = o == e ? p : e.getBoundingClientRect();
                var y = Math.max(o.offsetWidth, i(p.width)), v = Math.max(o.offsetHeight, i(p.height)), b = window.getComputedStyle(o);
                if (y -= parseFloat(b.paddingLeft) + parseFloat(b.paddingRight), v -= parseFloat(b.paddingTop) + parseFloat(b.paddingBottom), this.viewport.width = y, this.viewport.height = v, a) {
                    if (Math.abs(c - g.width) > .1 || Math.abs(u - g.height) > .1) {
                        var _$t = function(t, e, i, s) {
                            var o = Math.min(i / t || 0, s / e);
                            return {
                                width: t * o || 0,
                                height: e * o || 0
                            };
                        }(c, u, Math.min(c, g.width), Math.min(u, g.height));
                        h = i(_$t.width), _$l = i(_$t.height);
                    }
                    Object.assign(s.style, {
                        width: "".concat(h, "px"),
                        height: "".concat(_$l, "px"),
                        transform: ""
                    });
                }
                if (r && (Object.assign(o.style, {
                    width: "".concat(h, "px"),
                    height: "".concat(_$l, "px")
                }), this.viewport = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.viewport), {
                    width: h,
                    height: _$l
                })), n && a && "function" != typeof this.options.maxScale) {
                    var _$t1 = this.option("maxScale");
                    this.options.maxScale = function() {
                        return this.content.origWidth > 0 && this.content.fitWidth > 0 ? this.content.origWidth / this.content.fitWidth : _$t1;
                    };
                }
                this.content = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.content), {
                    origWidth: c,
                    origHeight: u,
                    fitWidth: h,
                    fitHeight: _$l,
                    width: h,
                    height: _$l,
                    scale: 1,
                    isZoomable: a
                }), this.container = {
                    width: m.width,
                    height: m.height
                }, !0 !== t && this.trigger("afterUpdate");
            }
        },
        {
            key: "zoomIn",
            value: function zoomIn(t) {
                this.zoomTo(this.content.scale + (t || this.option("step")));
            }
        },
        {
            key: "zoomOut",
            value: function zoomOut(t) {
                this.zoomTo(this.content.scale - (t || this.option("step")));
            }
        },
        {
            key: "toggleZoom",
            value: function toggleZoom() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var e = this.option("maxScale"), i = this.option("baseScale"), s = this.content.scale > i + .5 * (e - i) ? i : e;
                this.zoomTo(s, t);
            }
        },
        {
            key: "zoomTo",
            value: function zoomTo() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.option("baseScale"), ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = ref.x, e = tmp === void 0 ? null : tmp, tmp1 = ref.y, s = tmp1 === void 0 ? null : tmp1;
                t = Math.max(Math.min(t, this.option("maxScale")), this.option("minScale"));
                var o = i(this.content.scale / (this.content.width / this.content.fitWidth), 1e7);
                null === e && (e = this.content.width * o * .5), null === s && (s = this.content.height * o * .5);
                var ref1 = this.getZoomDelta(t, e, s), n = ref1.deltaX, a = ref1.deltaY;
                e = this.content.x - n, s = this.content.y - a, this.panTo({
                    x: e,
                    y: s,
                    scale: t,
                    friction: this.option("zoomFriction")
                });
            }
        },
        {
            key: "getZoomDelta",
            value: function getZoomDelta(t) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var s = this.content.fitWidth * this.content.scale, o = this.content.fitHeight * this.content.scale, n = e > 0 && s ? e / s : 0, a = i > 0 && o ? i / o : 0;
                return {
                    deltaX: (this.content.fitWidth * t - s) * n,
                    deltaY: (this.content.fitHeight * t - o) * a
                };
            }
        },
        {
            key: "panTo",
            value: function panTo() {
                var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = ref.x, t = tmp === void 0 ? this.content.x : tmp, tmp1 = ref.y, e = tmp1 === void 0 ? this.content.y : tmp1, i = ref.scale, tmp2 = ref.friction, s = tmp2 === void 0 ? this.option("friction") : tmp2, tmp3 = ref.ignoreBounds, o = tmp3 === void 0 ? !1 : tmp3;
                if (i = i || this.content.scale || 1, !o) {
                    var ref1 = this.getBounds(i), s1 = ref1.boundX, o1 = ref1.boundY;
                    s1 && (t = Math.max(Math.min(t, s1.to), s1.from)), o1 && (e = Math.max(Math.min(e, o1.to), o1.from));
                }
                this.friction = s, this.transform = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.transform), {
                    x: t,
                    y: e,
                    scale: i
                }), s ? (this.state = "panning", this.velocity = {
                    x: (1 / this.friction - 1) * (t - this.content.x),
                    y: (1 / this.friction - 1) * (e - this.content.y),
                    scale: (1 / this.friction - 1) * (i - this.content.scale)
                }, this.startAnimation()) : this.endAnimation();
            }
        },
        {
            key: "startAnimation",
            value: function startAnimation() {
                var _this = this;
                this.rAF ? cancelAnimationFrame(this.rAF) : this.trigger("startAnimation"), this.rAF = requestAnimationFrame(function() {
                    return _this.animate();
                });
            }
        },
        {
            key: "animate",
            value: function animate() {
                var _this = this;
                if (this.setEdgeForce(), this.setDragForce(), this.velocity.x *= this.friction, this.velocity.y *= this.friction, this.velocity.scale *= this.friction, this.content.x += this.velocity.x, this.content.y += this.velocity.y, this.content.scale += this.velocity.scale, this.isAnimating()) this.setTransform();
                else if ("pointerdown" !== this.state) return void this.endAnimation();
                this.rAF = requestAnimationFrame(function() {
                    return _this.animate();
                });
            }
        },
        {
            key: "getBounds",
            value: function getBounds(t) {
                var e = this.boundX, s = this.boundY;
                if (void 0 !== e && void 0 !== s) return {
                    boundX: e,
                    boundY: s
                };
                e = {
                    from: 0,
                    to: 0
                }, s = {
                    from: 0,
                    to: 0
                }, t = t || this.transform.scale;
                var o = this.content.fitWidth * t, n = this.content.fitHeight * t, a = this.viewport.width, r = this.viewport.height;
                if (o < a) {
                    var _$t = i(.5 * (a - o));
                    e.from = _$t, e.to = _$t;
                } else e.from = i(a - o);
                if (n < r) {
                    var _$t1 = .5 * (r - n);
                    s.from = _$t1, s.to = _$t1;
                } else s.from = i(r - n);
                return {
                    boundX: e,
                    boundY: s
                };
            }
        },
        {
            key: "setEdgeForce",
            value: function setEdgeForce() {
                if ("decel" !== this.state) return;
                var t = this.option("bounceForce"), ref = this.getBounds(Math.max(this.transform.scale, this.content.scale)), e = ref.boundX, i = ref.boundY;
                var s, o, n, a;
                if (e && (s = this.content.x < e.from, o = this.content.x > e.to), i && (n = this.content.y < i.from, a = this.content.y > i.to), s || o) {
                    var i1 = ((s ? e.from : e.to) - this.content.x) * t;
                    var o1 = this.content.x + (this.velocity.x + i1) / this.friction;
                    o1 >= e.from && o1 <= e.to && (i1 += this.velocity.x), this.velocity.x = i1, this.recalculateTransform();
                }
                if (n || a) {
                    var e1 = ((n ? i.from : i.to) - this.content.y) * t;
                    var s1 = this.content.y + (e1 + this.velocity.y) / this.friction;
                    s1 >= i.from && s1 <= i.to && (e1 += this.velocity.y), this.velocity.y = e1, this.recalculateTransform();
                }
            }
        },
        {
            key: "setDragResistance",
            value: function setDragResistance() {
                if ("pointerdown" !== this.state) return;
                var ref = this.getBounds(this.dragPosition.scale), t = ref.boundX, e = ref.boundY;
                var i, s, o, n;
                if (t && (i = this.dragPosition.x < t.from, s = this.dragPosition.x > t.to), e && (o = this.dragPosition.y < e.from, n = this.dragPosition.y > e.to), (i || s) && (!i || !s)) {
                    var e1 = i ? t.from : t.to, s1 = e1 - this.dragPosition.x;
                    this.dragPosition.x = e1 - .3 * s1;
                }
                if ((o || n) && (!o || !n)) {
                    var t1 = o ? e.from : e.to, i1 = t1 - this.dragPosition.y;
                    this.dragPosition.y = t1 - .3 * i1;
                }
            }
        },
        {
            key: "setDragForce",
            value: function setDragForce() {
                "pointerdown" === this.state && (this.velocity.x = this.dragPosition.x - this.content.x, this.velocity.y = this.dragPosition.y - this.content.y, this.velocity.scale = this.dragPosition.scale - this.content.scale);
            }
        },
        {
            key: "recalculateTransform",
            value: function recalculateTransform() {
                this.transform.x = this.content.x + this.velocity.x / (1 / this.friction - 1), this.transform.y = this.content.y + this.velocity.y / (1 / this.friction - 1), this.transform.scale = this.content.scale + this.velocity.scale / (1 / this.friction - 1);
            }
        },
        {
            key: "isAnimating",
            value: function isAnimating() {
                return !(!this.friction || !(Math.abs(this.velocity.x) > .05 || Math.abs(this.velocity.y) > .05 || Math.abs(this.velocity.scale) > .05));
            }
        },
        {
            key: "setTransform",
            value: function setTransform(t) {
                var e, s, o;
                if (t ? (e = i(this.transform.x), s = i(this.transform.y), o = this.transform.scale, this.content = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.content), {
                    x: e,
                    y: s,
                    scale: o
                })) : (e = i(this.content.x), s = i(this.content.y), o = this.content.scale / (this.content.width / this.content.fitWidth), this.content = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.content), {
                    x: e,
                    y: s
                })), this.trigger("beforeTransform"), e = i(this.content.x), s = i(this.content.y), t && this.option("zoom")) {
                    var _$t, n;
                    _$t = i(this.content.fitWidth * o), n = i(this.content.fitHeight * o), this.content.width = _$t, this.content.height = n, this.transform = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.transform), {
                        width: _$t,
                        height: n,
                        scale: o
                    }), Object.assign(this.$content.style, {
                        width: "".concat(_$t, "px"),
                        height: "".concat(n, "px"),
                        maxWidth: "none",
                        maxHeight: "none",
                        transform: "translate3d(".concat(e, "px, ").concat(s, "px, 0) scale(1)")
                    });
                } else this.$content.style.transform = "translate3d(".concat(e, "px, ").concat(s, "px, 0) scale(").concat(o, ")");
                this.trigger("afterTransform");
            }
        },
        {
            key: "endAnimation",
            value: function endAnimation(t) {
                cancelAnimationFrame(this.rAF), this.rAF = null, this.velocity = {
                    x: 0,
                    y: 0,
                    scale: 0
                }, this.setTransform(!0), this.state = "ready", this.handleCursor(), !0 !== t && this.trigger("endAnimation");
            }
        },
        {
            key: "handleCursor",
            value: function handleCursor() {
                var t = this.option("draggableClass");
                t && this.option("touch") && (1 == this.option("panOnlyZoomed") && this.content.width <= this.viewport.width && this.content.height <= this.viewport.height && this.transform.scale <= this.option("baseScale") ? this.$container.classList.remove(t) : this.$container.classList.add(t));
            }
        },
        {
            key: "detachEvents",
            value: function detachEvents() {
                this.$content.removeEventListener("load", this.onLoad), this.$container.removeEventListener("wheel", this.onWheel, {
                    passive: !1
                }), this.$container.removeEventListener("click", this.onClick, {
                    passive: !1
                }), this.pointerTracker && (this.pointerTracker.stop(), this.pointerTracker = null), this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                "destroy" !== this.state && (this.state = "destroy", clearTimeout(this.updateTimer), this.updateTimer = null, cancelAnimationFrame(this.rAF), this.rAF = null, this.detachEvents(), this.detachPlugins(), this.resetDragPosition());
            }
        }
    ]);
    return d;
}(l);
d.version = "4.0.31", d.Plugins = {};
var u = function(t, e) {
    var i = 0;
    return function u() {
        for(var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++){
            s[_key] = arguments[_key];
        }
        var o = (new Date).getTime();
        if (!(o - i < e)) return i = o, t.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(s));
    };
};
var f = /*#__PURE__*/ function() {
    "use strict";
    function f(t) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, f);
        this.$container = null, this.$prev = null, this.$next = null, this.carousel = t, this.onRefresh = this.onRefresh.bind(this);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(f, [
        {
            key: "option",
            value: function option(t) {
                return this.carousel.option("Navigation.".concat(t));
            }
        },
        {
            key: "createButton",
            value: function createButton(t) {
                var _this = this;
                var _classList;
                var e = document.createElement("button");
                e.setAttribute("title", this.carousel.localize("{{".concat(t.toUpperCase(), "}}")));
                var i = this.option("classNames.button") + " " + this.option("classNames.".concat(t));
                return (_classList = e.classList).add.apply(_classList, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(i.split(" "))), e.setAttribute("tabindex", "0"), e.innerHTML = this.carousel.localize(this.option("".concat(t, "Tpl"))), e.addEventListener("click", function(e) {
                    e.preventDefault(), e.stopPropagation(), _this.carousel["slide" + ("next" === t ? "Next" : "Prev")]();
                }), e;
            }
        },
        {
            key: "build",
            value: function build() {
                var _classList;
                this.$container || (this.$container = document.createElement("div"), (_classList = this.$container.classList).add.apply(_classList, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this.option("classNames.main").split(" "))), this.carousel.$container.appendChild(this.$container)), this.$next || (this.$next = this.createButton("next"), this.$container.appendChild(this.$next)), this.$prev || (this.$prev = this.createButton("prev"), this.$container.appendChild(this.$prev));
            }
        },
        {
            key: "onRefresh",
            value: function onRefresh() {
                var t = this.carousel.pages.length;
                t <= 1 || t > 1 && this.carousel.elemDimWidth < this.carousel.wrapDimWidth && !Number.isInteger(this.carousel.option("slidesPerPage")) ? this.cleanup() : (this.build(), this.$prev.removeAttribute("disabled"), this.$next.removeAttribute("disabled"), this.carousel.option("infiniteX", this.carousel.option("infinite")) || (this.carousel.page <= 0 && this.$prev.setAttribute("disabled", ""), this.carousel.page >= t - 1 && this.$next.setAttribute("disabled", "")));
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                this.$prev && this.$prev.remove(), this.$prev = null, this.$next && this.$next.remove(), this.$next = null, this.$container && this.$container.remove(), this.$container = null;
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.carousel.on("refresh change", this.onRefresh);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.carousel.off("refresh change", this.onRefresh), this.cleanup();
            }
        }
    ]);
    return f;
}();
f.defaults = {
    prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>',
    nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
    classNames: {
        main: "carousel__nav",
        button: "carousel__button",
        next: "is-next",
        prev: "is-prev"
    }
};
var g = /*#__PURE__*/ function() {
    "use strict";
    function g(t) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, g);
        this.carousel = t, this.selectedIndex = null, this.friction = 0, this.onNavReady = this.onNavReady.bind(this), this.onNavClick = this.onNavClick.bind(this), this.onNavCreateSlide = this.onNavCreateSlide.bind(this), this.onTargetChange = this.onTargetChange.bind(this);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(g, [
        {
            key: "addAsTargetFor",
            value: function addAsTargetFor(t) {
                this.target = this.carousel, this.nav = t, this.attachEvents();
            }
        },
        {
            key: "addAsNavFor",
            value: function addAsNavFor(t) {
                this.target = t, this.nav = this.carousel, this.attachEvents();
            }
        },
        {
            key: "attachEvents",
            value: function attachEvents() {
                this.nav.options.initialSlide = this.target.options.initialPage, this.nav.on("ready", this.onNavReady), this.nav.on("createSlide", this.onNavCreateSlide), this.nav.on("Panzoom.click", this.onNavClick), this.target.on("change", this.onTargetChange), this.target.on("Panzoom.afterUpdate", this.onTargetChange);
            }
        },
        {
            key: "onNavReady",
            value: function onNavReady() {
                this.onTargetChange(!0);
            }
        },
        {
            key: "onNavClick",
            value: function onNavClick(t, e, i) {
                var s = i.target.closest(".carousel__slide");
                if (!s) return;
                i.stopPropagation();
                var o = parseInt(s.dataset.index, 10), n = this.target.findPageForSlide(o);
                this.target.page !== n && this.target.slideTo(n, {
                    friction: this.friction
                }), this.markSelectedSlide(o);
            }
        },
        {
            key: "onNavCreateSlide",
            value: function onNavCreateSlide(t, e) {
                e.index === this.selectedIndex && this.markSelectedSlide(e.index);
            }
        },
        {
            key: "onTargetChange",
            value: function onTargetChange() {
                var t = this.target.pages[this.target.page].indexes[0], e = this.nav.findPageForSlide(t);
                this.nav.slideTo(e), this.markSelectedSlide(t);
            }
        },
        {
            key: "markSelectedSlide",
            value: function markSelectedSlide(t) {
                this.selectedIndex = t, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this.nav.slides).filter(function(t) {
                    return t.$el && t.$el.classList.remove("is-nav-selected");
                });
                var e = this.nav.slides[t];
                e && e.$el && e.$el.classList.add("is-nav-selected");
            }
        },
        {
            key: "attach",
            value: function attach(t) {
                var e = t.options.Sync;
                (e.target || e.nav) && (e.target ? this.addAsNavFor(e.target) : e.nav && this.addAsTargetFor(e.nav), this.friction = e.friction);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.nav && (this.nav.off("ready", this.onNavReady), this.nav.off("Panzoom.click", this.onNavClick), this.nav.off("createSlide", this.onNavCreateSlide)), this.target && (this.target.off("Panzoom.afterUpdate", this.onTargetChange), this.target.off("change", this.onTargetChange));
            }
        }
    ]);
    return g;
}();
g.defaults = {
    friction: .92
};
var p = {
    Navigation: f,
    Dots: /*#__PURE__*/ function() {
        "use strict";
        function Dots(t) {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Dots);
            this.carousel = t, this.$list = null, this.events = {
                change: this.onChange.bind(this),
                refresh: this.onRefresh.bind(this)
            };
        }
        (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Dots, [
            {
                key: "buildList",
                value: function buildList() {
                    var _this = this;
                    if (this.carousel.pages.length < this.carousel.option("Dots.minSlideCount")) return;
                    var t = document.createElement("ol");
                    return t.classList.add("carousel__dots"), t.addEventListener("click", function(t) {
                        if (!("page" in t.target.dataset)) return;
                        t.preventDefault(), t.stopPropagation();
                        var e = parseInt(t.target.dataset.page, 10), i = _this.carousel;
                        e !== i.page && (i.pages.length < 3 && i.option("infinite") ? i[0 == e ? "slidePrev" : "slideNext"]() : i.slideTo(e));
                    }), this.$list = t, this.carousel.$container.appendChild(t), this.carousel.$container.classList.add("has-dots"), t;
                }
            },
            {
                key: "removeList",
                value: function removeList() {
                    this.$list && (this.$list.parentNode.removeChild(this.$list), this.$list = null), this.carousel.$container.classList.remove("has-dots");
                }
            },
            {
                key: "rebuildDots",
                value: function rebuildDots() {
                    var t = this.$list;
                    var e = !!t, i = this.carousel.pages.length;
                    if (i < 2) return void (e && this.removeList());
                    e || (t = this.buildList());
                    var s = this.$list.children.length;
                    if (s > i) for(var t1 = i; t1 < s; t1++)this.$list.removeChild(this.$list.lastChild);
                    else {
                        var _this = this, _loop = function(t2) {
                            var e = document.createElement("li");
                            e.classList.add("carousel__dot"), e.dataset.page = t2, e.setAttribute("role", "button"), e.setAttribute("tabindex", "0"), e.setAttribute("title", _this.carousel.localize("{{GOTO}}", [
                                [
                                    "%d",
                                    t2 + 1
                                ]
                            ])), e.addEventListener("keydown", function(t) {
                                var i = t.code;
                                var s;
                                "Enter" === i || "NumpadEnter" === i ? s = e : "ArrowRight" === i ? s = e.nextSibling : "ArrowLeft" === i && (s = e.previousSibling), s && s.click();
                            }), _this.$list.appendChild(e);
                        };
                        for(var t2 = s; t2 < i; t2++)_loop(t2);
                        this.setActiveDot();
                    }
                }
            },
            {
                key: "setActiveDot",
                value: function setActiveDot() {
                    if (!this.$list) return;
                    this.$list.childNodes.forEach(function(t) {
                        t.classList.remove("is-selected");
                    });
                    var t = this.$list.childNodes[this.carousel.page];
                    t && t.classList.add("is-selected");
                }
            },
            {
                key: "onChange",
                value: function onChange() {
                    this.setActiveDot();
                }
            },
            {
                key: "onRefresh",
                value: function onRefresh() {
                    this.rebuildDots();
                }
            },
            {
                key: "attach",
                value: function attach() {
                    this.carousel.on(this.events);
                }
            },
            {
                key: "detach",
                value: function detach() {
                    this.removeList(), this.carousel.off(this.events), this.carousel = null;
                }
            }
        ]);
        return Dots;
    }(),
    Sync: g
};
var m = {
    slides: [],
    preload: 0,
    slidesPerPage: "auto",
    initialPage: null,
    initialSlide: null,
    friction: .92,
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    prefix: "",
    classNames: {
        viewport: "carousel__viewport",
        track: "carousel__track",
        slide: "carousel__slide",
        slideSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var y = /*#__PURE__*/ function(l) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(y, l);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(y);
    function y(t) {
        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, y);
        var _this;
        if (_this = _super.call(this, i = e(!0, {}, m, i)), _this.state = "init", _this.$container = t, !(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_this.$container, HTMLElement)) throw new Error("No root element provided");
        _this.slideNext = u(_this.slideNext.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this)), 250), _this.slidePrev = u(_this.slidePrev.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this)), 250), _this.init(), t.__Carousel = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this);
        return (0,_swc_helpers_src_possible_constructor_return_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(y, [
        {
            key: "init",
            value: function init() {
                this.pages = [], this.page = this.pageIndex = null, this.prevPage = this.prevPageIndex = null, this.attachPlugins(y.Plugins), this.trigger("init"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.$track && this.pages.length && (this.$track.style.transform = "translate3d(".concat(-1 * this.pages[this.page].left, "px, 0px, 0) scale(1)")), this.manageSlideVisiblity(), this.initPanzoom(), this.state = "ready", this.trigger("ready");
            }
        },
        {
            key: "initLayout",
            value: function initLayout() {
                var _classList, _$viewport, _classList1, _$track;
                var t = this.option("prefix"), e = this.option("classNames");
                this.$viewport = this.option("viewport") || this.$container.querySelector(".".concat(t).concat(e.viewport)), this.$viewport || (this.$viewport = document.createElement("div"), (_classList = this.$viewport.classList).add.apply(_classList, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((t + e.viewport).split(" "))), (_$viewport = this.$viewport).append.apply(_$viewport, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this.$container.childNodes)), this.$container.appendChild(this.$viewport)), this.$track = this.option("track") || this.$container.querySelector(".".concat(t).concat(e.track)), this.$track || (this.$track = document.createElement("div"), (_classList1 = this.$track.classList).add.apply(_classList1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((t + e.track).split(" "))), (_$track = this.$track).append.apply(_$track, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this.$viewport.childNodes)), this.$viewport.appendChild(this.$track));
            }
        },
        {
            key: "initSlides",
            value: function initSlides() {
                var _this = this;
                this.slides = [];
                this.$viewport.querySelectorAll(".".concat(this.option("prefix")).concat(this.option("classNames.slide"))).forEach(function(t) {
                    var e = {
                        $el: t,
                        isDom: !0
                    };
                    _this.slides.push(e), _this.trigger("createSlide", e, _this.slides.length);
                }), Array.isArray(this.options.slides) && (this.slides = e(!0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this.slides), this.options.slides));
            }
        },
        {
            key: "updateMetrics",
            value: function updateMetrics() {
                var _this = this;
                var t, e = 0, s = [];
                this.slides.forEach(function(i, o) {
                    var n = i.$el, a = i.isDom || !t ? _this.getSlideMetrics(n) : t;
                    i.index = o, i.width = a, i.left = e, t = a, e += a, s.push(o);
                });
                var o = Math.max(this.$track.offsetWidth, i(this.$track.getBoundingClientRect().width)), n = getComputedStyle(this.$track);
                o -= parseFloat(n.paddingLeft) + parseFloat(n.paddingRight), this.contentWidth = e, this.viewportWidth = o;
                var a = [], r = this.option("slidesPerPage");
                if (Number.isInteger(r) && e > o) for(var t1 = 0; t1 < this.slides.length; t1 += r)a.push({
                    indexes: s.slice(t1, t1 + r),
                    slides: this.slides.slice(t1, t1 + r)
                });
                else {
                    var t2 = 0, e1 = 0;
                    for(var i1 = 0; i1 < this.slides.length; i1 += 1){
                        var s1 = this.slides[i1];
                        (!a.length || e1 + s1.width > o) && (a.push({
                            indexes: [],
                            slides: []
                        }), t2 = a.length - 1, e1 = 0), e1 += s1.width, a[t2].indexes.push(i1), a[t2].slides.push(s1);
                    }
                }
                var h = this.option("center"), _$l = this.option("fill");
                a.forEach(function(t, i) {
                    t.index = i, t.width = t.slides.reduce(function(t, e) {
                        return t + e.width;
                    }, 0), t.left = t.slides[0].left, h && (t.left += .5 * (o - t.width) * -1), _$l && !_this.option("infiniteX", _this.option("infinite")) && e > o && (t.left = Math.max(t.left, 0), t.left = Math.min(t.left, e - o));
                });
                var c = [];
                var d;
                a.forEach(function(t) {
                    var e = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, t);
                    d && e.left === d.left ? (d.width += e.width, d.slides = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(d.slides).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e.slides)), d.indexes = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(d.indexes).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e.indexes))) : (e.index = c.length, d = e, c.push(e));
                }), this.pages = c;
                var u = this.page;
                if (null === u) {
                    var t3 = this.option("initialSlide");
                    u = null !== t3 ? this.findPageForSlide(t3) : parseInt(this.option("initialPage", 0), 10) || 0, c[u] || (u = c.length && u > c.length ? c[c.length - 1].index : 0), this.page = u, this.pageIndex = u;
                }
                this.updatePanzoom(), this.trigger("refresh");
            }
        },
        {
            key: "getSlideMetrics",
            value: function getSlideMetrics(t) {
                if (!t) {
                    var _classList, _classList1;
                    var e = this.slides[0];
                    (t = document.createElement("div")).dataset.isTestEl = 1, t.style.visibility = "hidden", (_classList = t.classList).add.apply(_classList, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((this.option("prefix") + this.option("classNames.slide")).split(" "))), e.customClass && (_classList1 = t.classList).add.apply(_classList1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e.customClass.split(" "))), this.$track.prepend(t);
                }
                var e1 = Math.max(t.offsetWidth, i(t.getBoundingClientRect().width));
                var s = t.currentStyle || window.getComputedStyle(t);
                return e1 = e1 + (parseFloat(s.marginLeft) || 0) + (parseFloat(s.marginRight) || 0), t.dataset.isTestEl && t.remove(), e1;
            }
        },
        {
            key: "findPageForSlide",
            value: function findPageForSlide(t) {
                t = parseInt(t, 10) || 0;
                var e = this.pages.find(function(e) {
                    return e.indexes.indexOf(t) > -1;
                });
                return e ? e.index : null;
            }
        },
        {
            key: "slideNext",
            value: function slideNext() {
                this.slideTo(this.pageIndex + 1);
            }
        },
        {
            key: "slidePrev",
            value: function slidePrev() {
                this.slideTo(this.pageIndex - 1);
            }
        },
        {
            key: "slideTo",
            value: function slideTo(t) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var tmp = e.x, i = tmp === void 0 ? -1 * this.setPage(t, !0) : tmp, tmp1 = e.y, s = tmp1 === void 0 ? 0 : tmp1, tmp2 = e.friction, o = tmp2 === void 0 ? this.option("friction") : tmp2;
                this.Panzoom.content.x === i && !this.Panzoom.velocity.x && o || (this.Panzoom.panTo({
                    x: i,
                    y: s,
                    friction: o,
                    ignoreBounds: !0
                }), "ready" === this.state && "ready" === this.Panzoom.state && this.trigger("settle"));
            }
        },
        {
            key: "initPanzoom",
            value: function initPanzoom() {
                var _this = this;
                this.Panzoom && this.Panzoom.destroy();
                var t = e(!0, {}, {
                    content: this.$track,
                    wrapInner: !1,
                    resizeParent: !1,
                    zoom: !1,
                    click: !1,
                    lockAxis: "x",
                    x: this.pages.length ? -1 * this.pages[this.page].left : 0,
                    centerOnStart: !1,
                    textSelection: function() {
                        return _this.option("textSelection", !1);
                    },
                    panOnlyZoomed: function panOnlyZoomed() {
                        return this.content.width <= this.viewport.width;
                    }
                }, this.option("Panzoom"));
                this.Panzoom = new d(this.$container, t), this.Panzoom.on({
                    "*": function(t) {
                        for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            e[_key - 1] = arguments[_key];
                        }
                        return _this.trigger.apply(_this, [
                            "Panzoom.".concat(t)
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e)));
                    },
                    afterUpdate: function() {
                        _this.updatePage();
                    },
                    beforeTransform: this.onBeforeTransform.bind(this),
                    touchEnd: this.onTouchEnd.bind(this),
                    endAnimation: function() {
                        _this.trigger("settle");
                    }
                }), this.updateMetrics(), this.manageSlideVisiblity();
            }
        },
        {
            key: "updatePanzoom",
            value: function updatePanzoom() {
                this.Panzoom && (this.Panzoom.content = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.Panzoom.content), {
                    fitWidth: this.contentWidth,
                    origWidth: this.contentWidth,
                    width: this.contentWidth
                }), this.pages.length > 1 && this.option("infiniteX", this.option("infinite")) ? this.Panzoom.boundX = null : this.pages.length && (this.Panzoom.boundX = {
                    from: -1 * this.pages[this.pages.length - 1].left,
                    to: -1 * this.pages[0].left
                }), this.option("infiniteY", this.option("infinite")) ? this.Panzoom.boundY = null : this.Panzoom.boundY = {
                    from: 0,
                    to: 0
                }, this.Panzoom.handleCursor());
            }
        },
        {
            key: "manageSlideVisiblity",
            value: function manageSlideVisiblity() {
                var _this = this;
                var t = this.contentWidth, e = this.viewportWidth;
                var i = this.Panzoom ? -1 * this.Panzoom.content.x : this.pages.length ? this.pages[this.page].left : 0;
                var s = this.option("preload"), o = this.option("infiniteX", this.option("infinite")), n = parseFloat(getComputedStyle(this.$viewport, null).getPropertyValue("padding-left")), a = parseFloat(getComputedStyle(this.$viewport, null).getPropertyValue("padding-right"));
                this.slides.forEach(function(r) {
                    var h, _$l, c = 0;
                    h = i - n, _$l = i + e + a, h -= s * (e + n + a), _$l += s * (e + n + a);
                    var d = r.left + r.width > h && r.left < _$l;
                    h = i + t - n, _$l = i + t + e + a, h -= s * (e + n + a);
                    var u = o && r.left + r.width > h && r.left < _$l;
                    h = i - t - n, _$l = i - t + e + a, h -= s * (e + n + a);
                    var f = o && r.left + r.width > h && r.left < _$l;
                    u || d || f ? (_this.createSlideEl(r), d && (c = 0), u && (c = -1), f && (c = 1), r.left + r.width > i && r.left <= i + e + a && (c = 0)) : _this.removeSlideEl(r), r.hasDiff = c;
                });
                var r = 0, h = 0;
                this.slides.forEach(function(e, i) {
                    var s = 0;
                    e.$el ? (i !== r || e.hasDiff ? s = h + e.hasDiff * t : h = 0, e.$el.style.left = Math.abs(s) > .1 ? "".concat(h + e.hasDiff * t, "px") : "", r++) : h += e.width;
                }), this.markSelectedSlides();
            }
        },
        {
            key: "createSlideEl",
            value: function createSlideEl(t) {
                var _classList, _classList1;
                if (!t) return;
                if (t.$el) {
                    var e = t.$el.dataset.index;
                    if (!e || parseInt(e, 10) !== t.index) {
                        var e1;
                        t.$el.dataset.index = t.index, t.$el.querySelectorAll("[data-lazy-srcset]").forEach(function(t) {
                            t.srcset = t.dataset.lazySrcset;
                        }), t.$el.querySelectorAll("[data-lazy-src]").forEach(function(t) {
                            var e = t.dataset.lazySrc;
                            (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, HTMLImageElement) ? t.src = e : t.style.backgroundImage = "url('".concat(e, "')");
                        }), (e1 = t.$el.dataset.lazySrc) && (t.$el.style.backgroundImage = "url('".concat(e1, "')")), t.state = "ready";
                    }
                    return;
                }
                var e2 = document.createElement("div");
                e2.dataset.index = t.index, (_classList = e2.classList).add.apply(_classList, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((this.option("prefix") + this.option("classNames.slide")).split(" "))), t.customClass && (_classList1 = e2.classList).add.apply(_classList1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(t.customClass.split(" "))), t.html && (e2.innerHTML = t.html);
                var i = [];
                this.slides.forEach(function(t, e) {
                    t.$el && i.push(e);
                });
                var s = t.index;
                var o = null;
                if (i.length) {
                    var _$t = i.reduce(function(t, e) {
                        return Math.abs(e - s) < Math.abs(t - s) ? e : t;
                    });
                    o = this.slides[_$t];
                }
                return this.$track.insertBefore(e2, o && o.$el ? o.index < t.index ? o.$el.nextSibling : o.$el : null), t.$el = e2, this.trigger("createSlide", t, s), t;
            }
        },
        {
            key: "removeSlideEl",
            value: function removeSlideEl(t) {
                t.$el && !t.isDom && (this.trigger("removeSlide", t), t.$el.remove(), t.$el = null);
            }
        },
        {
            key: "markSelectedSlides",
            value: function markSelectedSlides() {
                var _this = this;
                var t = this.option("classNames.slideSelected"), e = "aria-hidden";
                this.slides.forEach(function(i, s) {
                    var o = i.$el;
                    if (!o) return;
                    var n = _this.pages[_this.page];
                    n && n.indexes && n.indexes.indexOf(s) > -1 ? (t && !o.classList.contains(t) && (o.classList.add(t), _this.trigger("selectSlide", i)), o.removeAttribute(e)) : (t && o.classList.contains(t) && (o.classList.remove(t), _this.trigger("unselectSlide", i)), o.setAttribute(e, !0));
                });
            }
        },
        {
            key: "updatePage",
            value: function updatePage() {
                this.updateMetrics(), this.slideTo(this.page, {
                    friction: 0
                });
            }
        },
        {
            key: "onBeforeTransform",
            value: function onBeforeTransform() {
                this.option("infiniteX", this.option("infinite")) && this.manageInfiniteTrack(), this.manageSlideVisiblity();
            }
        },
        {
            key: "manageInfiniteTrack",
            value: function manageInfiniteTrack() {
                var t = this.contentWidth, e = this.viewportWidth;
                if (!this.option("infiniteX", this.option("infinite")) || this.pages.length < 2 || t < e) return;
                var i = this.Panzoom;
                var s = !1;
                return i.content.x < -1 * (t - e) && (i.content.x += t, this.pageIndex = this.pageIndex - this.pages.length, s = !0), i.content.x > e && (i.content.x -= t, this.pageIndex = this.pageIndex + this.pages.length, s = !0), s && "pointerdown" === i.state && i.resetDragPosition(), s;
            }
        },
        {
            key: "onTouchEnd",
            value: function onTouchEnd(t, e) {
                var i = this.option("dragFree");
                if (!i && this.pages.length > 1 && t.dragOffset.time < 350 && Math.abs(t.dragOffset.y) < 1 && Math.abs(t.dragOffset.x) > 5) this[t.dragOffset.x < 0 ? "slideNext" : "slidePrev"]();
                else if (i) {
                    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this.getPageFromPosition(-1 * t.transform.x), 2), e1 = ref[1];
                    this.setPage(e1);
                } else this.slideToClosest();
            }
        },
        {
            key: "slideToClosest",
            value: function slideToClosest() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this.getPageFromPosition(-1 * this.Panzoom.content.x), 2), e = ref[1];
                this.slideTo(e, t);
            }
        },
        {
            key: "getPageFromPosition",
            value: function getPageFromPosition(t) {
                var e = this.pages.length;
                this.option("center") && (t += .5 * this.viewportWidth);
                var i = Math.floor(t / this.contentWidth);
                t -= i * this.contentWidth;
                var s = this.slides.find(function(e) {
                    return e.left <= t && e.left + e.width > t;
                });
                if (s) {
                    var _$t = this.findPageForSlide(s.index);
                    return [
                        _$t,
                        _$t + i * e
                    ];
                }
                return [
                    0,
                    0
                ];
            }
        },
        {
            key: "setPage",
            value: function setPage(t, e) {
                var i = 0, s = parseInt(t, 10) || 0;
                var o = this.page, n = this.pageIndex, a = this.pages.length, r = this.contentWidth, h = this.viewportWidth;
                if (t = (s % a + a) % a, this.option("infiniteX", this.option("infinite")) && r > h) {
                    var o1 = Math.floor(s / a) || 0, n1 = r;
                    if (i = this.pages[t].left + o1 * n1, !0 === e && a > 2) {
                        var _$t = -1 * this.Panzoom.content.x;
                        var _$e = i - n1, o2 = i + n1, r1 = Math.abs(_$t - i), h1 = Math.abs(_$t - _$e), _$l = Math.abs(_$t - o2);
                        _$l < r1 && _$l <= h1 ? (i = o2, s += a) : h1 < r1 && h1 < _$l && (i = _$e, s -= a);
                    }
                } else t = s = Math.max(0, Math.min(s, a - 1)), i = this.pages.length ? this.pages[t].left : 0;
                return this.page = t, this.pageIndex = s, null !== o && t !== o && (this.prevPage = o, this.prevPageIndex = n, this.trigger("change", t, o)), i;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                this.state = "destroy", this.slides.forEach(function(t) {
                    _this.removeSlideEl(t);
                }), this.slides = [], this.Panzoom.destroy(), this.detachPlugins();
            }
        }
    ]);
    return y;
}(l);
y.version = "4.0.31", y.Plugins = p;
var v = !( false || !window.document || !window.document.createElement);
var b = null;
var x = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
], w = function(t) {
    if (t && v) {
        null === b && document.createElement("div").focus({
            get preventScroll () {
                return b = !0, !1;
            }
        });
        try {
            if (t.setActive) t.setActive();
            else if (b) t.focus({
                preventScroll: !0
            });
            else {
                var e = window.pageXOffset || document.body.scrollTop, i = window.pageYOffset || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t1) {}
    }
};
var $ = {
    minSlideCount: 2,
    minScreenHeight: 500,
    autoStart: !0,
    key: "t",
    Carousel: {},
    tpl: '<div class="fancybox__thumb" style="background-image:url(\'{{src}}\')"></div>'
};
var C = /*#__PURE__*/ function() {
    "use strict";
    function C(t) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, C);
        this.fancybox = t, this.$container = null, this.state = "init";
        for(var _i = 0, _iter = [
            "onPrepare",
            "onClosing",
            "onKeydown"
        ]; _i < _iter.length; _i++){
            var _$t = _iter[_i];
            this[_$t] = this[_$t].bind(this);
        }
        this.events = {
            prepare: this.onPrepare,
            closing: this.onClosing,
            keydown: this.onKeydown
        };
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(C, [
        {
            key: "onPrepare",
            value: function onPrepare() {
                this.getSlides().length < this.fancybox.option("Thumbs.minSlideCount") ? this.state = "disabled" : !0 === this.fancybox.option("Thumbs.autoStart") && this.fancybox.Carousel.Panzoom.content.height >= this.fancybox.option("Thumbs.minScreenHeight") && this.build();
            }
        },
        {
            key: "onClosing",
            value: function onClosing() {
                this.Carousel && this.Carousel.Panzoom.detachEvents();
            }
        },
        {
            key: "onKeydown",
            value: function onKeydown(t, e) {
                e === t.option("Thumbs.key") && this.toggle();
            }
        },
        {
            key: "build",
            value: function build() {
                var _this = this;
                if (this.$container) return;
                var t = document.createElement("div");
                t.classList.add("fancybox__thumbs"), this.fancybox.$carousel.parentNode.insertBefore(t, this.fancybox.$carousel.nextSibling), this.Carousel = new y(t, e(!0, {
                    Dots: !1,
                    Navigation: !1,
                    Sync: {
                        friction: 0
                    },
                    infinite: !1,
                    center: !0,
                    fill: !0,
                    dragFree: !0,
                    slidesPerPage: 1,
                    preload: 1
                }, this.fancybox.option("Thumbs.Carousel"), {
                    Sync: {
                        target: this.fancybox.Carousel
                    },
                    slides: this.getSlides()
                })), this.Carousel.Panzoom.on("wheel", function(t, e) {
                    e.preventDefault(), _this.fancybox[e.deltaY < 0 ? "prev" : "next"]();
                }), this.$container = t, this.state = "visible";
            }
        },
        {
            key: "getSlides",
            value: function getSlides() {
                var t = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fancybox.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e = _step.value;
                        var i = e.thumb;
                        i && t.push({
                            html: this.fancybox.option("Thumbs.tpl").replace(/\{\{src\}\}/gi, i),
                            customClass: "has-thumb has-".concat(e.type || "image")
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return t;
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                "visible" === this.state ? this.hide() : "hidden" === this.state ? this.show() : this.build();
            }
        },
        {
            key: "show",
            value: function show() {
                "hidden" === this.state && (this.$container.style.display = "", this.Carousel.Panzoom.attachEvents(), this.state = "visible");
            }
        },
        {
            key: "hide",
            value: function hide() {
                "visible" === this.state && (this.Carousel.Panzoom.detachEvents(), this.$container.style.display = "none", this.state = "hidden");
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                this.Carousel && (this.Carousel.destroy(), this.Carousel = null), this.$container && (this.$container.remove(), this.$container = null), this.state = "init";
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.fancybox.on(this.events);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.fancybox.off(this.events), this.cleanup();
            }
        }
    ]);
    return C;
}();
C.defaults = $;
var S = function(t, e) {
    var i = new URL(t), s = new URLSearchParams(i.search);
    var o = new URLSearchParams;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(s).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Object.entries(e)))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_step.value, 2), _$t = _value[0], i1 = _value[1];
            "t" === _$t ? o.set("start", parseInt(i1)) : o.set(_$t, i1);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    o = o.toString();
    var n = t.match(/#t=((.*)?\d+s)/);
    return n && (o += "#t=".concat(n[1])), o;
}, E = {
    video: {
        autoplay: !0,
        ratio: 16 / 9
    },
    youtube: {
        autohide: 1,
        fs: 1,
        rel: 0,
        hd: 1,
        wmode: "transparent",
        enablejsapi: 1,
        html5: 1
    },
    vimeo: {
        hd: 1,
        show_title: 1,
        show_byline: 1,
        show_portrait: 0,
        fullscreen: 1
    },
    html5video: {
        tpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
        format: ""
    }
};
var P = /*#__PURE__*/ function() {
    "use strict";
    function P(t) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, P);
        this.fancybox = t;
        for(var _i = 0, _iter = [
            "onInit",
            "onReady",
            "onCreateSlide",
            "onRemoveSlide",
            "onSelectSlide",
            "onUnselectSlide",
            "onRefresh",
            "onMessage"
        ]; _i < _iter.length; _i++){
            var _$t = _iter[_i];
            this[_$t] = this[_$t].bind(this);
        }
        this.events = {
            init: this.onInit,
            ready: this.onReady,
            "Carousel.createSlide": this.onCreateSlide,
            "Carousel.removeSlide": this.onRemoveSlide,
            "Carousel.selectSlide": this.onSelectSlide,
            "Carousel.unselectSlide": this.onUnselectSlide,
            "Carousel.refresh": this.onRefresh
        };
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(P, [
        {
            key: "onInit",
            value: function onInit() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fancybox.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        this.processType(t);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processType",
            value: function processType(t) {
                if (t.html) return t.src = t.html, t.type = "html", void delete t.html;
                var i = t.src || "";
                var s = t.type || this.fancybox.options.type, o = null;
                if (!i || "string" == typeof i) {
                    if (o = i.match(/(?:youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
                        var e1 = S(i, this.fancybox.option("Html.youtube")), n = encodeURIComponent(o[1]);
                        t.videoId = n, t.src = "https://www.youtube-nocookie.com/embed/".concat(n, "?").concat(e1), t.thumb = t.thumb || "https://i.ytimg.com/vi/".concat(n, "/mqdefault.jpg"), t.vendor = "youtube", s = "video";
                    } else if (o = i.match(/^.+vimeo.com\/(?:\/)?([\d]+)(.*)?/)) {
                        var e2 = S(i, this.fancybox.option("Html.vimeo")), n1 = encodeURIComponent(o[1]);
                        t.videoId = n1, t.src = "https://player.vimeo.com/video/".concat(n1, "?").concat(e2), t.vendor = "vimeo", s = "video";
                    } else (o = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = "//maps.google.".concat(o[1], "/?ll=").concat((o[2] ? o[2] + "&z=" + Math.floor(o[3]) + (o[4] ? o[4].replace(/^\//, "&") : "") : o[4] + "").replace(/\?/, "&"), "&output=").concat(o[4] && o[4].indexOf("layer=c") > 0 ? "svembed" : "embed"), s = "map") : (o = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = "//maps.google.".concat(o[1], "/maps?q=").concat(o[2].replace("query=", "q=").replace("api=1", ""), "&output=embed"), s = "map");
                    s || ("#" === i.charAt(0) ? s = "inline" : (o = i.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (s = "html5video", t.format = t.format || "video/" + ("ogv" === o[1] ? "ogg" : o[1])) : i.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? s = "image" : i.match(/\.(pdf)((\?|#).*)?$/i) && (s = "pdf")), t.type = s || this.fancybox.option("defaultType", "image"), "html5video" !== s && "video" !== s || (t.video = e({}, this.fancybox.option("Html.video"), t.video), t._width && t._height ? t.ratio = parseFloat(t._width) / parseFloat(t._height) : t.ratio = t.ratio || t.video.ratio || E.video.ratio);
                }
            }
        },
        {
            key: "onReady",
            value: function onReady() {
                var _this = this;
                this.fancybox.Carousel.slides.forEach(function(t) {
                    t.$el && (_this.setContent(t), t.index === _this.fancybox.getSlide().index && _this.playVideo(t));
                });
            }
        },
        {
            key: "onCreateSlide",
            value: function onCreateSlide(t, e, i) {
                "ready" === this.fancybox.state && this.setContent(i);
            }
        },
        {
            key: "loadInlineContent",
            value: function loadInlineContent(t) {
                var e;
                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t.src, HTMLElement)) e = t.src;
                else if ("string" == typeof t.src) {
                    var i = t.src.split("#", 2), s = 2 === i.length && "" === i[0] ? i[1] : i[0];
                    e = document.getElementById(s);
                }
                if (e) {
                    if ("clone" === t.type || e.$placeHolder) {
                        e = e.cloneNode(!0);
                        var i1 = e.getAttribute("id");
                        i1 = i1 ? "".concat(i1, "--clone") : "clone-".concat(this.fancybox.id, "-").concat(t.index), e.setAttribute("id", i1);
                    } else {
                        var _$t = document.createElement("div");
                        _$t.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(_$t, e), e.$placeHolder = _$t;
                    }
                    this.fancybox.setContent(t, e);
                } else this.fancybox.setError(t, "{{ELEMENT_NOT_FOUND}}");
            }
        },
        {
            key: "loadAjaxContent",
            value: function loadAjaxContent(t) {
                var e = this.fancybox, i = new XMLHttpRequest;
                e.showLoading(t), i.onreadystatechange = function() {
                    i.readyState === XMLHttpRequest.DONE && "ready" === e.state && (e.hideLoading(t), 200 === i.status ? e.setContent(t, i.responseText) : e.setError(t, 404 === i.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
                };
                var s = t.ajax || null;
                i.open(s ? "POST" : "GET", t.src), i.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), i.setRequestHeader("X-Requested-With", "XMLHttpRequest"), i.send(s), t.xhr = i;
            }
        },
        {
            key: "loadIframeContent",
            value: function loadIframeContent(t) {
                var _this = this;
                var e = this.fancybox, i = document.createElement("iframe");
                if (i.className = "fancybox__iframe", i.setAttribute("id", "fancybox__iframe_".concat(e.id, "_").concat(t.index)), i.setAttribute("allow", "autoplay; fullscreen"), i.setAttribute("scrolling", "auto"), t.$iframe = i, "iframe" !== t.type || !1 === t.preload) return i.setAttribute("src", t.src), this.fancybox.setContent(t, i), void this.resizeIframe(t);
                e.showLoading(t);
                var s = document.createElement("div");
                s.style.visibility = "hidden", this.fancybox.setContent(t, s), s.appendChild(i), i.onerror = function() {
                    e.setError(t, "{{IFRAME_ERROR}}");
                }, i.onload = function() {
                    e.hideLoading(t);
                    var s = !1;
                    i.isReady || (i.isReady = !0, s = !0), i.src.length && (i.parentNode.style.visibility = "", _this.resizeIframe(t), s && e.revealContent(t));
                }, i.setAttribute("src", t.src);
            }
        },
        {
            key: "setAspectRatio",
            value: function setAspectRatio(t) {
                var e = t.$content, i = t.ratio;
                if (!e) return;
                var s = t._width, o = t._height;
                if (i || s && o) {
                    Object.assign(e.style, {
                        width: s && o ? "100%" : "",
                        height: s && o ? "100%" : "",
                        maxWidth: "",
                        maxHeight: ""
                    });
                    var _$t = e.offsetWidth, n = e.offsetHeight;
                    if (s = s || _$t, o = o || n, s > _$t || o > n) {
                        var e1 = Math.min(_$t / s, n / o);
                        s *= e1, o *= e1;
                    }
                    Math.abs(s / o - i) > .01 && (i < s / o ? s = o * i : o = s / i), Object.assign(e.style, {
                        width: "".concat(s, "px"),
                        height: "".concat(o, "px")
                    });
                }
            }
        },
        {
            key: "resizeIframe",
            value: function resizeIframe(t) {
                var e = t.$iframe;
                if (!e) return;
                var i = t._width || 0, s = t._height || 0;
                i && s && (t.autoSize = !1);
                var o = e.parentNode, n = o && o.style;
                if (!1 !== t.preload && !1 !== t.autoSize && n) try {
                    var _$t = window.getComputedStyle(o), a = parseFloat(_$t.paddingLeft) + parseFloat(_$t.paddingRight), r = parseFloat(_$t.paddingTop) + parseFloat(_$t.paddingBottom), h = e.contentWindow.document, l = h.getElementsByTagName("html")[0], c = h.body;
                    n.width = "", c.style.overflow = "hidden", i = i || l.scrollWidth + a, n.width = "".concat(i, "px"), c.style.overflow = "", n.flex = "0 0 auto", n.height = "".concat(c.scrollHeight, "px"), s = l.scrollHeight + r;
                } catch (t1) {}
                if (i || s) {
                    var _$t1 = {
                        flex: "0 1 auto"
                    };
                    i && (_$t1.width = "".concat(i, "px")), s && (_$t1.height = "".concat(s, "px")), Object.assign(n, _$t1);
                }
            }
        },
        {
            key: "onRefresh",
            value: function onRefresh(t, e) {
                var _this = this;
                e.slides.forEach(function(t) {
                    t.$el && (t.$iframe && _this.resizeIframe(t), t.ratio && _this.setAspectRatio(t));
                });
            }
        },
        {
            key: "setContent",
            value: function setContent(t) {
                if (t && !t.isDom) {
                    switch(t.type){
                        case "html":
                            this.fancybox.setContent(t, t.src);
                            break;
                        case "html5video":
                            this.fancybox.setContent(t, this.fancybox.option("Html.html5video.tpl").replace(/\{\{src\}\}/gi, t.src).replace("{{format}}", t.format || t.html5video && t.html5video.format || "").replace("{{poster}}", t.poster || t.thumb || ""));
                            break;
                        case "inline":
                        case "clone":
                            this.loadInlineContent(t);
                            break;
                        case "ajax":
                            this.loadAjaxContent(t);
                            break;
                        case "pdf":
                        case "video":
                        case "map":
                            t.preload = !1;
                        case "iframe":
                            this.loadIframeContent(t);
                    }
                    t.ratio && this.setAspectRatio(t);
                }
            }
        },
        {
            key: "onSelectSlide",
            value: function onSelectSlide(t, e, i) {
                "ready" === t.state && this.playVideo(i);
            }
        },
        {
            key: "playVideo",
            value: function playVideo(t) {
                if ("html5video" === t.type && t.video.autoplay) try {
                    var e = t.$el.querySelector("video");
                    if (e) {
                        var _$t = e.play();
                        void 0 !== _$t && _$t.then(function() {}).catch(function(t) {
                            e.muted = !0, e.play();
                        });
                    }
                } catch (t1) {}
                if ("video" !== t.type || !t.$iframe || !t.$iframe.contentWindow) return;
                var e1 = function() {
                    if ("done" === t.state && t.$iframe && t.$iframe.contentWindow) {
                        var e;
                        if (t.$iframe.isReady) return t.video && t.video.autoplay && (e = "youtube" == t.vendor ? {
                            event: "command",
                            func: "playVideo"
                        } : {
                            method: "play",
                            value: "true"
                        }), void (e && t.$iframe.contentWindow.postMessage(JSON.stringify(e), "*"));
                        "youtube" === t.vendor && (e = {
                            event: "listening",
                            id: t.$iframe.getAttribute("id")
                        }, t.$iframe.contentWindow.postMessage(JSON.stringify(e), "*"));
                    }
                    t.poller = setTimeout(e1, 250);
                };
                e1();
            }
        },
        {
            key: "onUnselectSlide",
            value: function onUnselectSlide(t, e, i) {
                if ("html5video" === i.type) {
                    try {
                        i.$el.querySelector("video").pause();
                    } catch (t1) {}
                    return;
                }
                var s = !1;
                "vimeo" == i.vendor ? s = {
                    method: "pause",
                    value: "true"
                } : "youtube" === i.vendor && (s = {
                    event: "command",
                    func: "pauseVideo"
                }), s && i.$iframe && i.$iframe.contentWindow && i.$iframe.contentWindow.postMessage(JSON.stringify(s), "*"), clearTimeout(i.poller);
            }
        },
        {
            key: "onRemoveSlide",
            value: function onRemoveSlide(t, e, i) {
                i.xhr && (i.xhr.abort(), i.xhr = null), i.$iframe && (i.$iframe.onload = i.$iframe.onerror = null, i.$iframe.src = "//about:blank", i.$iframe = null);
                var s = i.$content;
                "inline" === i.type && s && (s.classList.remove("fancybox__content"), "none" !== s.style.display && (s.style.display = "none")), i.$closeButton && (i.$closeButton.remove(), i.$closeButton = null);
                var o = s && s.$placeHolder;
                o && (o.parentNode.insertBefore(s, o), o.remove(), s.$placeHolder = null);
            }
        },
        {
            key: "onMessage",
            value: function onMessage(t) {
                try {
                    var e = JSON.parse(t.data);
                    if ("https://player.vimeo.com" === t.origin) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if ("ready" === e.event) try {
                            for(var _iterator = document.getElementsByClassName("fancybox__iframe")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var e1 = _step.value;
                                e1.contentWindow === t.source && (e1.isReady = 1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    } else "https://www.youtube-nocookie.com" === t.origin && "onReady" === e.event && (document.getElementById(e.id).isReady = 1);
                } catch (t1) {}
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.fancybox.on(this.events), window.addEventListener("message", this.onMessage, !1);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.fancybox.off(this.events), window.removeEventListener("message", this.onMessage, !1);
            }
        }
    ]);
    return P;
}();
P.defaults = E;
var T = /*#__PURE__*/ function() {
    "use strict";
    function T(t) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, T);
        this.fancybox = t;
        for(var _i = 0, _iter = [
            "onReady",
            "onClosing",
            "onDone",
            "onPageChange",
            "onCreateSlide",
            "onRemoveSlide",
            "onImageStatusChange"
        ]; _i < _iter.length; _i++){
            var _$t = _iter[_i];
            this[_$t] = this[_$t].bind(this);
        }
        this.events = {
            ready: this.onReady,
            closing: this.onClosing,
            done: this.onDone,
            "Carousel.change": this.onPageChange,
            "Carousel.createSlide": this.onCreateSlide,
            "Carousel.removeSlide": this.onRemoveSlide
        };
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(T, [
        {
            key: "onReady",
            value: function onReady() {
                var _this = this;
                this.fancybox.Carousel.slides.forEach(function(t) {
                    t.$el && _this.setContent(t);
                });
            }
        },
        {
            key: "onDone",
            value: function onDone(t, e) {
                this.handleCursor(e);
            }
        },
        {
            key: "onClosing",
            value: function onClosing(t) {
                clearTimeout(this.clickTimer), this.clickTimer = null, t.Carousel.slides.forEach(function(t) {
                    t.$image && (t.state = "destroy"), t.Panzoom && t.Panzoom.detachEvents();
                }), "closing" === this.fancybox.state && this.canZoom(t.getSlide()) && this.zoomOut();
            }
        },
        {
            key: "onCreateSlide",
            value: function onCreateSlide(t, e, i) {
                "ready" === this.fancybox.state && this.setContent(i);
            }
        },
        {
            key: "onRemoveSlide",
            value: function onRemoveSlide(t, e, i) {
                i.$image && (i.$el.classList.remove(t.option("Image.canZoomInClass")), i.$image.remove(), i.$image = null), i.Panzoom && (i.Panzoom.destroy(), i.Panzoom = null), i.$el && i.$el.dataset && delete i.$el.dataset.imageFit;
            }
        },
        {
            key: "setContent",
            value: function setContent(t) {
                var _this = this;
                if (t.isDom || t.html || t.type && "image" !== t.type) return;
                if (t.$image) return;
                t.type = "image", t.state = "loading";
                var e = document.createElement("div");
                e.style.visibility = "hidden";
                var i = document.createElement("img");
                i.addEventListener("load", function(e) {
                    e.stopImmediatePropagation(), _this.onImageStatusChange(t);
                }), i.addEventListener("error", function() {
                    _this.onImageStatusChange(t);
                }), i.src = t.src, i.alt = "", i.draggable = !1, i.classList.add("fancybox__image"), t.srcset && i.setAttribute("srcset", t.srcset), t.sizes && i.setAttribute("sizes", t.sizes), t.$image = i;
                var s = this.fancybox.option("Image.wrap");
                if (s) {
                    var o = document.createElement("div");
                    o.classList.add("string" == typeof s ? s : "fancybox__image-wrap"), o.appendChild(i), e.appendChild(o), t.$wrap = o;
                } else e.appendChild(i);
                t.$el.dataset.imageFit = this.fancybox.option("Image.fit"), this.fancybox.setContent(t, e), i.complete || i.error ? this.onImageStatusChange(t) : this.fancybox.showLoading(t);
            }
        },
        {
            key: "onImageStatusChange",
            value: function onImageStatusChange(t) {
                var _this = this;
                var e = t.$image;
                e && "loading" === t.state && (e.complete && e.naturalWidth && e.naturalHeight ? (this.fancybox.hideLoading(t), "contain" === this.fancybox.option("Image.fit") && this.initSlidePanzoom(t), t.$el.addEventListener("wheel", function(e) {
                    return _this.onWheel(t, e);
                }, {
                    passive: !1
                }), t.$content.addEventListener("click", function(e) {
                    return _this.onClick(t, e);
                }, {
                    passive: !1
                }), this.revealContent(t)) : this.fancybox.setError(t, "{{IMAGE_ERROR}}"));
            }
        },
        {
            key: "initSlidePanzoom",
            value: function initSlidePanzoom(t) {
                var _this = this;
                t.Panzoom || (t.Panzoom = new d(t.$el, e(!0, this.fancybox.option("Image.Panzoom", {}), {
                    viewport: t.$wrap,
                    content: t.$image,
                    width: t._width,
                    height: t._height,
                    wrapInner: !1,
                    textSelection: !0,
                    touch: this.fancybox.option("Image.touch"),
                    panOnlyZoomed: !0,
                    click: !1,
                    wheel: !1
                })), t.Panzoom.on("startAnimation", function() {
                    _this.fancybox.trigger("Image.startAnimation", t);
                }), t.Panzoom.on("endAnimation", function() {
                    "zoomIn" === t.state && _this.fancybox.done(t), _this.handleCursor(t), _this.fancybox.trigger("Image.endAnimation", t);
                }), t.Panzoom.on("afterUpdate", function() {
                    _this.handleCursor(t), _this.fancybox.trigger("Image.afterUpdate", t);
                }));
            }
        },
        {
            key: "revealContent",
            value: function revealContent(t) {
                null === this.fancybox.Carousel.prevPage && t.index === this.fancybox.options.startIndex && this.canZoom(t) ? this.zoomIn() : this.fancybox.revealContent(t);
            }
        },
        {
            key: "getZoomInfo",
            value: function getZoomInfo(t) {
                var e = t.$thumb.getBoundingClientRect(), i = e.width, s = e.height, o = t.$content.getBoundingClientRect(), n = o.width, a = o.height, r = o.top - e.top, h = o.left - e.left;
                var l = this.fancybox.option("Image.zoomOpacity");
                return "auto" === l && (l = Math.abs(i / s - n / a) > .1), {
                    top: r,
                    left: h,
                    scale: n && i ? i / n : 1,
                    opacity: l
                };
            }
        },
        {
            key: "canZoom",
            value: function canZoom(t) {
                var e = this.fancybox, i = e.$container;
                if (window.visualViewport && 1 !== window.visualViewport.scale) return !1;
                if (t.Panzoom && !t.Panzoom.content.width) return !1;
                if (!e.option("Image.zoom") || "contain" !== e.option("Image.fit")) return !1;
                var s = t.$thumb;
                if (!s || "loading" === t.state) return !1;
                i.classList.add("fancybox__no-click");
                var o = s.getBoundingClientRect();
                var n;
                if (this.fancybox.option("Image.ignoreCoveredThumbnail")) {
                    var _$t = document.elementFromPoint(o.left + 1, o.top + 1) === s, e1 = document.elementFromPoint(o.right - 1, o.bottom - 1) === s;
                    n = _$t && e1;
                } else n = document.elementFromPoint(o.left + .5 * o.width, o.top + .5 * o.height) === s;
                return i.classList.remove("fancybox__no-click"), n;
            }
        },
        {
            key: "zoomIn",
            value: function zoomIn() {
                var t = this.fancybox, e = t.getSlide(), i = e.Panzoom, ref = this.getZoomInfo(e), s = ref.top, o = ref.left, n = ref.scale, a = ref.opacity;
                t.trigger("reveal", e), i.panTo({
                    x: -1 * o,
                    y: -1 * s,
                    scale: n,
                    friction: 0,
                    ignoreBounds: !0
                }), e.$content.style.visibility = "", e.state = "zoomIn", !0 === a && i.on("afterTransform", function(t) {
                    "zoomIn" !== e.state && "zoomOut" !== e.state || (t.$content.style.opacity = Math.min(1, 1 - (1 - t.content.scale) / (1 - n)));
                }), i.panTo({
                    x: 0,
                    y: 0,
                    scale: 1,
                    friction: this.fancybox.option("Image.zoomFriction")
                });
            }
        },
        {
            key: "zoomOut",
            value: function zoomOut() {
                var _this = this;
                var t = this.fancybox, e = t.getSlide(), i = e.Panzoom;
                if (!i) return;
                e.state = "zoomOut", t.state = "customClosing", e.$caption && (e.$caption.style.visibility = "hidden");
                var s = this.fancybox.option("Image.zoomFriction");
                var o = function(t) {
                    var ref = _this.getZoomInfo(e), o = ref.top, n = ref.left, a = ref.scale, r = ref.opacity;
                    t || r || (s *= .82), i.panTo({
                        x: -1 * n,
                        y: -1 * o,
                        scale: a,
                        friction: s,
                        ignoreBounds: !0
                    }), s *= .98;
                };
                window.addEventListener("scroll", o), i.once("endAnimation", function() {
                    window.removeEventListener("scroll", o), t.destroy();
                }), o();
            }
        },
        {
            key: "handleCursor",
            value: function handleCursor(t) {
                if ("image" !== t.type || !t.$el) return;
                var e = t.Panzoom, i = this.fancybox.option("Image.click", !1, t), s = this.fancybox.option("Image.touch"), o = t.$el.classList, n = this.fancybox.option("Image.canZoomInClass"), a = this.fancybox.option("Image.canZoomOutClass");
                if (o.remove(a), o.remove(n), e && "toggleZoom" === i) {
                    e && 1 === e.content.scale && e.option("maxScale") - e.content.scale > .01 ? o.add(n) : e.content.scale > 1 && !s && o.add(a);
                } else "close" === i && o.add(a);
            }
        },
        {
            key: "onWheel",
            value: function onWheel(t, e) {
                if ("ready" === this.fancybox.state && !1 !== this.fancybox.trigger("Image.wheel", e)) switch(this.fancybox.option("Image.wheel")){
                    case "zoom":
                        "done" === t.state && t.Panzoom && t.Panzoom.zoomWithWheel(e);
                        break;
                    case "close":
                        this.fancybox.close();
                        break;
                    case "slide":
                        this.fancybox[e.deltaY < 0 ? "prev" : "next"]();
                }
            }
        },
        {
            key: "onClick",
            value: function onClick(t, e) {
                var _this = this;
                if ("ready" !== this.fancybox.state) return;
                var i = t.Panzoom;
                if (i && (i.dragPosition.midPoint || 0 !== i.dragOffset.x || 0 !== i.dragOffset.y || 1 !== i.dragOffset.scale)) return;
                if (this.fancybox.Carousel.Panzoom.lockAxis) return !1;
                var s = function(i) {
                    switch(i){
                        case "toggleZoom":
                            e.stopPropagation(), t.Panzoom && t.Panzoom.zoomWithClick(e);
                            break;
                        case "close":
                            _this.fancybox.close();
                            break;
                        case "next":
                            e.stopPropagation(), _this.fancybox.next();
                    }
                }, o = this.fancybox.option("Image.click"), n = this.fancybox.option("Image.doubleClick");
                n ? this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null, s(n)) : this.clickTimer = setTimeout(function() {
                    _this.clickTimer = null, s(o);
                }, 300) : s(o);
            }
        },
        {
            key: "onPageChange",
            value: function onPageChange(t, e) {
                var i = t.getSlide();
                e.slides.forEach(function(t) {
                    t.Panzoom && "done" === t.state && t.index !== i.index && t.Panzoom.panTo({
                        x: 0,
                        y: 0,
                        scale: 1,
                        friction: .8
                    });
                });
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.fancybox.on(this.events);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.fancybox.off(this.events);
            }
        }
    ]);
    return T;
}();
T.defaults = {
    canZoomInClass: "can-zoom_in",
    canZoomOutClass: "can-zoom_out",
    zoom: !0,
    zoomOpacity: "auto",
    zoomFriction: .82,
    ignoreCoveredThumbnail: !1,
    touch: !0,
    click: "toggleZoom",
    doubleClick: null,
    wheel: "zoom",
    fit: "contain",
    wrap: !1,
    Panzoom: {
        ratio: 1
    }
};
var L = /*#__PURE__*/ function() {
    "use strict";
    function L(t) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, L);
        this.fancybox = t;
        for(var _i = 0, _iter = [
            "onChange",
            "onClosing"
        ]; _i < _iter.length; _i++){
            var _$t = _iter[_i];
            this[_$t] = this[_$t].bind(this);
        }
        this.events = {
            initCarousel: this.onChange,
            "Carousel.change": this.onChange,
            closing: this.onClosing
        }, this.hasCreatedHistory = !1, this.origHash = "", this.timer = null;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(L, [
        {
            key: "onChange",
            value: function onChange(t) {
                var _this = this;
                var e = t.Carousel;
                this.timer && clearTimeout(this.timer);
                var i = null === e.prevPage, s = t.getSlide(), o = new URL(document.URL).hash;
                var n = !1;
                if (s.slug) n = "#" + s.slug;
                else {
                    var i1 = s.$trigger && s.$trigger.dataset, o1 = t.option("slug") || i1 && i1.fancybox;
                    o1 && o1.length && "true" !== o1 && (n = "#" + o1 + (e.slides.length > 1 ? "-" + (s.index + 1) : ""));
                }
                i && (this.origHash = o !== n ? o : ""), n && o !== n && (this.timer = setTimeout(function() {
                    try {
                        window.history[i ? "pushState" : "replaceState"]({}, document.title, window.location.pathname + window.location.search + n), i && (_this.hasCreatedHistory = !0);
                    } catch (t) {}
                }, 300));
            }
        },
        {
            key: "onClosing",
            value: function onClosing() {
                if (this.timer && clearTimeout(this.timer), !0 !== this.hasSilentClose) try {
                    return void window.history.replaceState({}, document.title, window.location.pathname + window.location.search + (this.origHash || ""));
                } catch (t) {}
            }
        },
        {
            key: "attach",
            value: function attach(t) {
                t.on(this.events);
            }
        },
        {
            key: "detach",
            value: function detach(t) {
                t.off(this.events);
            }
        }
    ], [
        {
            key: "startFromUrl",
            value: function startFromUrl() {
                var t = L.Fancybox;
                if (!t || t.getInstance() || !1 === t.defaults.Hash) return;
                var ref = L.getParsedURL(), e = ref.hash, i = ref.slug, s = ref.index;
                if (!i) return;
                var o = document.querySelector('[data-slug="'.concat(e, '"]'));
                if (o && o.dispatchEvent(new CustomEvent("click", {
                    bubbles: !0,
                    cancelable: !0
                })), t.getInstance()) return;
                var n = document.querySelectorAll('[data-fancybox="'.concat(i, '"]'));
                n.length && (null === s && 1 === n.length ? o = n[0] : s && (o = n[s - 1]), o && o.dispatchEvent(new CustomEvent("click", {
                    bubbles: !0,
                    cancelable: !0
                })));
            }
        },
        {
            key: "onHashChange",
            value: function onHashChange() {
                var ref = L.getParsedURL(), t = ref.slug, e = ref.index, i = L.Fancybox, s = i && i.getInstance();
                if (s && s.plugins.Hash) {
                    if (t) {
                        var i1 = s.Carousel;
                        if (t === s.option("slug")) return i1.slideTo(e - 1);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = i1.slides[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var e1 = _step.value;
                                if (e1.slug && e1.slug === t) return i1.slideTo(e1.index);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var o = s.getSlide(), n = o.$trigger && o.$trigger.dataset;
                        if (n && n.fancybox === t) return i1.slideTo(e - 1);
                    }
                    s.plugins.Hash.hasSilentClose = !0, s.close();
                }
                L.startFromUrl();
            }
        },
        {
            key: "create",
            value: function create(t) {
                var e = function e() {
                    window.addEventListener("hashchange", L.onHashChange, !1), L.startFromUrl();
                };
                L.Fancybox = t, v && window.requestAnimationFrame(function() {
                    /complete|interactive|loaded/.test(document.readyState) ? e() : document.addEventListener("DOMContentLoaded", e);
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                window.removeEventListener("hashchange", L.onHashChange, !1);
            }
        },
        {
            key: "getParsedURL",
            value: function getParsedURL() {
                var t = window.location.hash.substr(1), e = t.split("-"), i = e.length > 1 && /^\+?\d+$/.test(e[e.length - 1]) && parseInt(e.pop(-1), 10) || null;
                return {
                    hash: t,
                    slug: e.join("-"),
                    index: i
                };
            }
        }
    ]);
    return L;
}();
var _ = {
    pageXOffset: 0,
    pageYOffset: 0,
    element: function() {
        return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
    },
    activate: function activate(t) {
        _.pageXOffset = window.pageXOffset, _.pageYOffset = window.pageYOffset, t.requestFullscreen ? t.requestFullscreen() : t.mozRequestFullScreen ? t.mozRequestFullScreen() : t.webkitRequestFullscreen ? t.webkitRequestFullscreen() : t.msRequestFullscreen && t.msRequestFullscreen();
    },
    deactivate: function deactivate() {
        document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen && document.webkitExitFullscreen();
    }
};
var A = /*#__PURE__*/ function() {
    "use strict";
    function A(t) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, A);
        this.fancybox = t, this.active = !1, this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(A, [
        {
            key: "isActive",
            value: function isActive() {
                return this.active;
            }
        },
        {
            key: "setTimer",
            value: function setTimer() {
                var _this = this;
                if (!this.active || this.timer) return;
                var t = this.fancybox.option("slideshow.delay", 3e3);
                this.timer = setTimeout(function() {
                    _this.timer = null, _this.fancybox.option("infinite") || _this.fancybox.getSlide().index !== _this.fancybox.Carousel.slides.length - 1 ? _this.fancybox.next() : _this.fancybox.jumpTo(0, {
                        friction: 0
                    });
                }, t);
                var e = this.$progress;
                e || (e = document.createElement("div"), e.classList.add("fancybox__progress"), this.fancybox.$carousel.parentNode.insertBefore(e, this.fancybox.$carousel), this.$progress = e, e.offsetHeight), e.style.transitionDuration = "".concat(t, "ms"), e.style.transform = "scaleX(1)";
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                clearTimeout(this.timer), this.timer = null, this.$progress && (this.$progress.style.transitionDuration = "", this.$progress.style.transform = "", this.$progress.offsetHeight);
            }
        },
        {
            key: "activate",
            value: function activate() {
                this.active || (this.active = !0, this.fancybox.$container.classList.add("has-slideshow"), "done" === this.fancybox.getSlide().state && this.setTimer(), document.addEventListener("visibilitychange", this.handleVisibilityChange, !1));
            }
        },
        {
            key: "handleVisibilityChange",
            value: function handleVisibilityChange() {
                this.deactivate();
            }
        },
        {
            key: "deactivate",
            value: function deactivate() {
                this.active = !1, this.clearTimer(), this.fancybox.$container.classList.remove("has-slideshow"), document.removeEventListener("visibilitychange", this.handleVisibilityChange, !1);
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                this.active ? this.deactivate() : this.fancybox.Carousel.slides.length > 1 && this.activate();
            }
        }
    ]);
    return A;
}();
var z = {
    display: [
        "counter",
        "zoom",
        "slideshow",
        "fullscreen",
        "thumbs",
        "close"
    ],
    autoEnable: !0,
    items: {
        counter: {
            position: "left",
            type: "div",
            class: "fancybox__counter",
            html: '<span data-fancybox-index=""></span>&nbsp;/&nbsp;<span data-fancybox-count=""></span>',
            attr: {
                tabindex: -1
            }
        },
        prev: {
            type: "button",
            class: "fancybox__button--prev",
            label: "PREV",
            html: '<svg viewBox="0 0 24 24"><path d="M15 4l-8 8 8 8"/></svg>',
            attr: {
                "data-fancybox-prev": ""
            }
        },
        next: {
            type: "button",
            class: "fancybox__button--next",
            label: "NEXT",
            html: '<svg viewBox="0 0 24 24"><path d="M8 4l8 8-8 8"/></svg>',
            attr: {
                "data-fancybox-next": ""
            }
        },
        fullscreen: {
            type: "button",
            class: "fancybox__button--fullscreen",
            label: "TOGGLE_FULLSCREEN",
            html: '<svg viewBox="0 0 24 24">\n                <g><path d="M3 8 V3h5"></path><path d="M21 8V3h-5"></path><path d="M8 21H3v-5"></path><path d="M16 21h5v-5"></path></g>\n                <g><path d="M7 2v5H2M17 2v5h5M2 17h5v5M22 17h-5v5"/></g>\n            </svg>',
            click: function click(t) {
                t.preventDefault(), _.element() ? _.deactivate() : _.activate(this.fancybox.$container);
            }
        },
        slideshow: {
            type: "button",
            class: "fancybox__button--slideshow",
            label: "TOGGLE_SLIDESHOW",
            html: '<svg viewBox="0 0 24 24">\n                <g><path d="M6 4v16"/><path d="M20 12L6 20"/><path d="M20 12L6 4"/></g>\n                <g><path d="M7 4v15M17 4v15"/></g>\n            </svg>',
            click: function click(t) {
                t.preventDefault(), this.Slideshow.toggle();
            }
        },
        zoom: {
            type: "button",
            class: "fancybox__button--zoom",
            label: "TOGGLE_ZOOM",
            html: '<svg viewBox="0 0 24 24"><circle cx="10" cy="10" r="7"></circle><path d="M16 16 L21 21"></svg>',
            click: function click(t) {
                t.preventDefault();
                var e = this.fancybox.getSlide().Panzoom;
                e && e.toggleZoom();
            }
        },
        download: {
            type: "link",
            label: "DOWNLOAD",
            class: "fancybox__button--download",
            html: '<svg viewBox="0 0 24 24"><path d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.62 2.48A2 2 0 004.56 21h14.88a2 2 0 001.94-1.51L22 17"/></svg>',
            click: function click(t) {
                t.stopPropagation();
            }
        },
        thumbs: {
            type: "button",
            label: "TOGGLE_THUMBS",
            class: "fancybox__button--thumbs",
            html: '<svg viewBox="0 0 24 24"><circle cx="4" cy="4" r="1" /><circle cx="12" cy="4" r="1" transform="rotate(90 12 4)"/><circle cx="20" cy="4" r="1" transform="rotate(90 20 4)"/><circle cx="4" cy="12" r="1" transform="rotate(90 4 12)"/><circle cx="12" cy="12" r="1" transform="rotate(90 12 12)"/><circle cx="20" cy="12" r="1" transform="rotate(90 20 12)"/><circle cx="4" cy="20" r="1" transform="rotate(90 4 20)"/><circle cx="12" cy="20" r="1" transform="rotate(90 12 20)"/><circle cx="20" cy="20" r="1" transform="rotate(90 20 20)"/></svg>',
            click: function click(t) {
                t.stopPropagation();
                var e = this.fancybox.plugins.Thumbs;
                e && e.toggle();
            }
        },
        close: {
            type: "button",
            label: "CLOSE",
            class: "fancybox__button--close",
            html: '<svg viewBox="0 0 24 24"><path d="M20 20L4 4m16 0L4 20"></path></svg>',
            attr: {
                "data-fancybox-close": "",
                tabindex: 0
            }
        }
    }
};
var k = /*#__PURE__*/ function() {
    "use strict";
    function k(t) {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, k);
        this.fancybox = t, this.$container = null, this.state = "init";
        for(var _i = 0, _iter = [
            "onInit",
            "onPrepare",
            "onDone",
            "onKeydown",
            "onClosing",
            "onChange",
            "onSettle",
            "onRefresh"
        ]; _i < _iter.length; _i++){
            var _$t = _iter[_i];
            this[_$t] = this[_$t].bind(this);
        }
        this.events = {
            init: this.onInit,
            prepare: this.onPrepare,
            done: this.onDone,
            keydown: this.onKeydown,
            closing: this.onClosing,
            "Carousel.change": this.onChange,
            "Carousel.settle": this.onSettle,
            "Carousel.Panzoom.touchStart": function() {
                return _this.onRefresh();
            },
            "Image.startAnimation": function(t, e) {
                return _this.onRefresh(e);
            },
            "Image.afterUpdate": function(t, e) {
                return _this.onRefresh(e);
            }
        };
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(k, [
        {
            key: "onInit",
            value: function onInit() {
                if (this.fancybox.option("Toolbar.autoEnable")) {
                    var t1 = !1;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.fancybox.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var e = _step.value;
                            if ("image" === e.type) {
                                t1 = !0;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!t1) return void (this.state = "disabled");
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.fancybox.option("Toolbar.display")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var e1 = _step1.value;
                        if ("close" === (t(e1) ? e1.id : e1)) {
                            this.fancybox.options.closeButton = !1;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "onPrepare",
            value: function onPrepare() {
                var t = this.fancybox;
                if ("init" === this.state && (this.build(), this.update(), this.Slideshow = new A(t), !t.Carousel.prevPage && (t.option("slideshow.autoStart") && this.Slideshow.activate(), t.option("fullscreen.autoStart") && !_.element()))) try {
                    _.activate(t.$container);
                } catch (t1) {}
            }
        },
        {
            key: "onFsChange",
            value: function onFsChange() {
                window.scrollTo(_.pageXOffset, _.pageYOffset);
            }
        },
        {
            key: "onSettle",
            value: function onSettle() {
                var t = this.fancybox, e = this.Slideshow;
                e && e.isActive() && (t.getSlide().index !== t.Carousel.slides.length - 1 || t.option("infinite") ? "done" === t.getSlide().state && e.setTimer() : e.deactivate());
            }
        },
        {
            key: "onChange",
            value: function onChange() {
                this.update(), this.Slideshow && this.Slideshow.isActive() && this.Slideshow.clearTimer();
            }
        },
        {
            key: "onDone",
            value: function onDone(t, e) {
                var i = this.Slideshow;
                e.index === t.getSlide().index && (this.update(), i && i.isActive() && (t.option("infinite") || e.index !== t.Carousel.slides.length - 1 ? i.setTimer() : i.deactivate()));
            }
        },
        {
            key: "onRefresh",
            value: function onRefresh(t) {
                t && t.index !== this.fancybox.getSlide().index || (this.update(), !this.Slideshow || !this.Slideshow.isActive() || t && "done" !== t.state || this.Slideshow.deactivate());
            }
        },
        {
            key: "onKeydown",
            value: function onKeydown(t, e, i) {
                " " === e && this.Slideshow && (this.Slideshow.toggle(), i.preventDefault());
            }
        },
        {
            key: "onClosing",
            value: function onClosing() {
                this.Slideshow && this.Slideshow.deactivate(), document.removeEventListener("fullscreenchange", this.onFsChange);
            }
        },
        {
            key: "createElement",
            value: function createElement(t) {
                var _classList;
                var e;
                "div" === t.type ? e = document.createElement("div") : (e = document.createElement("link" === t.type ? "a" : "button"), e.classList.add("carousel__button")), e.innerHTML = t.html, e.setAttribute("tabindex", t.tabindex || 0), t.class && (_classList = e.classList).add.apply(_classList, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(t.class.split(" ")));
                for(var i in t.attr)e.setAttribute(i, t.attr[i]);
                t.label && e.setAttribute("title", this.fancybox.localize("{{".concat(t.label, "}}"))), t.click && e.addEventListener("click", t.click.bind(this)), "prev" === t.id && e.setAttribute("data-fancybox-prev", ""), "next" === t.id && e.setAttribute("data-fancybox-next", "");
                var i1 = e.querySelector("svg");
                return i1 && (i1.setAttribute("role", "img"), i1.setAttribute("tabindex", "-1"), i1.setAttribute("xmlns", "http://www.w3.org/2000/svg")), e;
            }
        },
        {
            key: "build",
            value: function build() {
                this.cleanup();
                var i = this.fancybox.option("Toolbar.items"), s = [
                    {
                        position: "left",
                        items: []
                    },
                    {
                        position: "center",
                        items: []
                    },
                    {
                        position: "right",
                        items: []
                    }
                ], o = this.fancybox.plugins.Thumbs;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this = this, _loop = function() {
                        var n = _step.value;
                        var a = void 0, r = void 0;
                        if (t(n) ? (a = n.id, r = e({}, i[a], n)) : (a = n, r = i[a]), [
                            "counter",
                            "next",
                            "prev",
                            "slideshow"
                        ].includes(a) && _this.fancybox.items.length < 2) return "continue";
                        if ("fullscreen" === a) {
                            if (!document.fullscreenEnabled || window.fullScreen) return "continue";
                            document.addEventListener("fullscreenchange", _this.onFsChange);
                        }
                        if ("thumbs" === a && (!o || "disabled" === o.state)) return "continue";
                        if (!r) return "continue";
                        var h = r.position || "right", l = s.find(function(t) {
                            return t.position === h;
                        });
                        l && l.items.push(r);
                    };
                    for(var _iterator = this.fancybox.option("Toolbar.display")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var n = document.createElement("div");
                n.classList.add("fancybox__toolbar");
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = s[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var t1 = _step1.value;
                        if (t1.items.length) {
                            var e1 = document.createElement("div");
                            e1.classList.add("fancybox__toolbar__items"), e1.classList.add("fancybox__toolbar__items--".concat(t1.position));
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = t1.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var i1 = _step2.value;
                                    e1.appendChild(this.createElement(i1));
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                            n.appendChild(e1);
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                this.fancybox.$carousel.parentNode.insertBefore(n, this.fancybox.$carousel), this.$container = n;
            }
        },
        {
            key: "update",
            value: function update() {
                var t = this.fancybox.getSlide(), e = t.index, i = this.fancybox.items.length, s = t.downloadSrc || ("image" !== t.type || t.error ? null : t.src);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fancybox.$container.querySelectorAll("a.fancybox__button--download")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t1 = _step.value;
                        s ? (t1.removeAttribute("disabled"), t1.removeAttribute("tabindex"), t1.setAttribute("href", s), t1.setAttribute("download", s), t1.setAttribute("target", "_blank")) : (t1.setAttribute("disabled", ""), t1.setAttribute("tabindex", -1), t1.removeAttribute("href"), t1.removeAttribute("download"));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var o = t.Panzoom, n = o && o.option("maxScale") > o.option("baseScale");
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.fancybox.$container.querySelectorAll(".fancybox__button--zoom")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var t2 = _step1.value;
                        n ? t2.removeAttribute("disabled") : t2.setAttribute("disabled", "");
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = this.fancybox.$container.querySelectorAll("[data-fancybox-index]")[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var e1 = _step2.value;
                        e1.innerHTML = t.index + 1;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = this.fancybox.$container.querySelectorAll("[data-fancybox-count]")[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var t3 = _step3.value;
                        t3.innerHTML = i;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
                if (!this.fancybox.option("infinite")) {
                    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                    try {
                        for(var _iterator4 = this.fancybox.$container.querySelectorAll("[data-fancybox-prev]")[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                            var t4 = _step4.value;
                            0 === e ? t4.setAttribute("disabled", "") : t4.removeAttribute("disabled");
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                _iterator4.return();
                            }
                        } finally{
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                    try {
                        for(var _iterator5 = this.fancybox.$container.querySelectorAll("[data-fancybox-next]")[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                            var t5 = _step5.value;
                            e === i - 1 ? t5.setAttribute("disabled", "") : t5.removeAttribute("disabled");
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                _iterator5.return();
                            }
                        } finally{
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                this.Slideshow && this.Slideshow.isActive() && this.Slideshow.clearTimer(), this.$container && this.$container.remove(), this.$container = null;
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.fancybox.on(this.events);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.fancybox.off(this.events), this.cleanup();
            }
        }
    ]);
    return k;
}();
k.defaults = z;
var O = {
    ScrollLock: /*#__PURE__*/ function() {
        "use strict";
        function ScrollLock(t) {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, ScrollLock);
            this.fancybox = t, this.viewport = null, this.pendingUpdate = null;
            for(var _i = 0, _iter = [
                "onReady",
                "onResize",
                "onTouchstart",
                "onTouchmove"
            ]; _i < _iter.length; _i++){
                var _$t = _iter[_i];
                this[_$t] = this[_$t].bind(this);
            }
        }
        (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ScrollLock, [
            {
                key: "onReady",
                value: function onReady() {
                    var t = window.visualViewport;
                    t && (this.viewport = t, this.startY = 0, t.addEventListener("resize", this.onResize), this.updateViewport()), window.addEventListener("touchstart", this.onTouchstart, {
                        passive: !1
                    }), window.addEventListener("touchmove", this.onTouchmove, {
                        passive: !1
                    }), window.addEventListener("wheel", this.onWheel, {
                        passive: !1
                    });
                }
            },
            {
                key: "onResize",
                value: function onResize() {
                    this.updateViewport();
                }
            },
            {
                key: "updateViewport",
                value: function updateViewport() {
                    var t = this.fancybox, e = this.viewport, i = e.scale || 1, s = t.$container;
                    if (!s) return;
                    var o = "", n = "", a = "";
                    i - 1 > .1 && (o = e.width * i + "px", n = e.height * i + "px", a = "translate3d(".concat(e.offsetLeft, "px, ").concat(e.offsetTop, "px, 0) scale(").concat(1 / i, ")")), s.style.width = o, s.style.height = n, s.style.transform = a;
                }
            },
            {
                key: "onTouchstart",
                value: function onTouchstart(t) {
                    this.startY = t.touches ? t.touches[0].screenY : t.screenY;
                }
            },
            {
                key: "onTouchmove",
                value: function onTouchmove(t) {
                    var e = this.startY, i = window.innerWidth / window.document.documentElement.clientWidth;
                    if (!t.cancelable) return;
                    if (t.touches.length > 1 || 1 !== i) return;
                    var o = s(t.composedPath()[0]);
                    if (!o) return void t.preventDefault();
                    var n = window.getComputedStyle(o), a = parseInt(n.getPropertyValue("height"), 10), r = t.touches ? t.touches[0].screenY : t.screenY, h = e <= r && 0 === o.scrollTop, l = e >= r && o.scrollHeight - o.scrollTop === a;
                    (h || l) && t.preventDefault();
                }
            },
            {
                key: "onWheel",
                value: function onWheel(t) {
                    s(t.composedPath()[0]) || t.preventDefault();
                }
            },
            {
                key: "cleanup",
                value: function cleanup() {
                    this.pendingUpdate && (cancelAnimationFrame(this.pendingUpdate), this.pendingUpdate = null);
                    var t = this.viewport;
                    t && (t.removeEventListener("resize", this.onResize), this.viewport = null), window.removeEventListener("touchstart", this.onTouchstart, !1), window.removeEventListener("touchmove", this.onTouchmove, !1), window.removeEventListener("wheel", this.onWheel, {
                        passive: !1
                    });
                }
            },
            {
                key: "attach",
                value: function attach() {
                    this.fancybox.on("initLayout", this.onReady);
                }
            },
            {
                key: "detach",
                value: function detach() {
                    this.fancybox.off("initLayout", this.onReady), this.cleanup();
                }
            }
        ]);
        return ScrollLock;
    }(),
    Thumbs: C,
    Html: P,
    Toolbar: k,
    Image: T,
    Hash: L
};
var M = {
    startIndex: 0,
    preload: 1,
    infinite: !0,
    showClass: "fancybox-zoomInUp",
    hideClass: "fancybox-fadeOut",
    animated: !0,
    hideScrollbar: !0,
    parentEl: null,
    mainClass: null,
    autoFocus: !0,
    trapFocus: !0,
    placeFocusBack: !0,
    click: "close",
    closeButton: "inside",
    dragToClose: !0,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "next",
        ArrowDown: "prev",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    template: {
        closeButton: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg>',
        spinner: '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="25 25 50 50" tabindex="-1"><circle cx="50" cy="50" r="20"/></svg>',
        main: null
    },
    l10n: {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }
}, I = new Map;
var F = 0;
var R = /*#__PURE__*/ function(l) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(R, l);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(R);
    function R(t) {
        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, R);
        var _this;
        t = t.map(function(t) {
            return t.width && (t._width = t.width), t.height && (t._height = t.height), t;
        }), _this = _super.call(this, e(!0, {}, M, i)), _this.bindHandlers(), _this.state = "init", _this.setItems(t), _this.attachPlugins(R.Plugins), _this.trigger("init"), !0 === _this.option("hideScrollbar") && _this.hideScrollbar(), _this.initLayout(), _this.initCarousel(), _this.attachEvents(), I.set(_this.id, (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this)), _this.trigger("prepare"), _this.state = "ready", _this.trigger("ready"), _this.$container.setAttribute("aria-hidden", "false"), _this.option("trapFocus") && _this.focus();
        return (0,_swc_helpers_src_possible_constructor_return_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(R, [
        {
            key: "option",
            value: function option(t) {
                for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    e[_key - 1] = arguments[_key];
                }
                var _s, _instance;
                var i = this.getSlide();
                var s = i ? i[t] : void 0;
                return void 0 !== s ? ("function" == typeof s && (s = (_s = s).call.apply(_s, [
                    this,
                    this
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e)))), s) : (_instance = (0,_swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(R.prototype), "option", this)).call.apply(_instance, [
                    this,
                    t
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e)));
            }
        },
        {
            key: "bindHandlers",
            value: function bindHandlers() {
                for(var _i = 0, _iter = [
                    "onMousedown",
                    "onKeydown",
                    "onClick",
                    "onFocus",
                    "onCreateSlide",
                    "onSettle",
                    "onTouchMove",
                    "onTouchEnd",
                    "onTransform"
                ]; _i < _iter.length; _i++){
                    var t = _iter[_i];
                    this[t] = this[t].bind(this);
                }
            }
        },
        {
            key: "attachEvents",
            value: function attachEvents() {
                document.addEventListener("mousedown", this.onMousedown), document.addEventListener("keydown", this.onKeydown, !0), this.option("trapFocus") && document.addEventListener("focus", this.onFocus, !0), this.$container.addEventListener("click", this.onClick);
            }
        },
        {
            key: "detachEvents",
            value: function detachEvents() {
                document.removeEventListener("mousedown", this.onMousedown), document.removeEventListener("keydown", this.onKeydown, !0), document.removeEventListener("focus", this.onFocus, !0), this.$container.removeEventListener("click", this.onClick);
            }
        },
        {
            key: "initLayout",
            value: function initLayout() {
                var _this = this;
                var _$container, _classList;
                this.$root = this.option("parentEl") || document.body;
                var t = this.option("template.main");
                t && (this.$root.insertAdjacentHTML("beforeend", this.localize(t)), this.$container = this.$root.querySelector(".fancybox__container")), this.$container || (this.$container = document.createElement("div"), this.$root.appendChild(this.$container)), this.$container.onscroll = function() {
                    return _this.$container.scrollLeft = 0, !1;
                }, Object.entries({
                    class: "fancybox__container",
                    role: "dialog",
                    tabIndex: "-1",
                    "aria-modal": "true",
                    "aria-hidden": "true",
                    "aria-label": this.localize("{{MODAL}}")
                }).forEach(function(t) {
                    return (_$container = _this.$container).setAttribute.apply(_$container, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(t));
                }), this.option("animated") && this.$container.classList.add("is-animated"), this.$backdrop = this.$container.querySelector(".fancybox__backdrop"), this.$backdrop || (this.$backdrop = document.createElement("div"), this.$backdrop.classList.add("fancybox__backdrop"), this.$container.appendChild(this.$backdrop)), this.$carousel = this.$container.querySelector(".fancybox__carousel"), this.$carousel || (this.$carousel = document.createElement("div"), this.$carousel.classList.add("fancybox__carousel"), this.$container.appendChild(this.$carousel)), this.$container.Fancybox = this, this.id = this.$container.getAttribute("id"), this.id || (this.id = this.options.id || ++F, this.$container.setAttribute("id", "fancybox-" + this.id));
                var e = this.option("mainClass");
                return e && (_classList = this.$container.classList).add.apply(_classList, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e.split(" "))), document.documentElement.classList.add("with-fancybox"), this.trigger("initLayout"), this;
            }
        },
        {
            key: "setItems",
            value: function setItems(t) {
                var e = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var _$t = i.$trigger;
                        if (_$t) {
                            var e1 = _$t.dataset || {};
                            i.src = e1.src || _$t.getAttribute("href") || i.src, i.type = e1.type || i.type, !i.src && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_$t, HTMLImageElement) && (i.src = _$t.currentSrc || i.$trigger.src);
                        }
                        var s = i.$thumb;
                        if (!s) {
                            var _$t1 = i.$trigger && i.$trigger.origTarget;
                            _$t1 && (s = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_$t1, HTMLImageElement) ? _$t1 : _$t1.querySelector("img:not([aria-hidden])")), !s && i.$trigger && (s = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(i.$trigger, HTMLImageElement) ? i.$trigger : i.$trigger.querySelector("img:not([aria-hidden])"));
                        }
                        i.$thumb = s || null;
                        var o = i.thumb;
                        !o && s && (o = s.currentSrc || s.src, !o && s.dataset && (o = s.dataset.lazySrc || s.dataset.src)), o || "image" !== i.type || (o = i.src), i.thumb = o || null, i.caption = i.caption || "", e.push(i);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.items = e;
            }
        },
        {
            key: "initCarousel",
            value: function initCarousel() {
                var _this = this;
                return this.Carousel = new y(this.$carousel, e(!0, {}, {
                    prefix: "",
                    classNames: {
                        viewport: "fancybox__viewport",
                        track: "fancybox__track",
                        slide: "fancybox__slide"
                    },
                    textSelection: !0,
                    preload: this.option("preload"),
                    friction: .88,
                    slides: this.items,
                    initialPage: this.options.startIndex,
                    slidesPerPage: 1,
                    infiniteX: this.option("infinite"),
                    infiniteY: !0,
                    l10n: this.option("l10n"),
                    Dots: !1,
                    Navigation: {
                        classNames: {
                            main: "fancybox__nav",
                            button: "carousel__button",
                            next: "is-next",
                            prev: "is-prev"
                        }
                    },
                    Panzoom: {
                        textSelection: !0,
                        panOnlyZoomed: function() {
                            return _this.Carousel && _this.Carousel.pages && _this.Carousel.pages.length < 2 && !_this.option("dragToClose");
                        },
                        lockAxis: function() {
                            if (_this.Carousel) {
                                var t = "x";
                                return _this.option("dragToClose") && (t += "y"), t;
                            }
                        }
                    },
                    on: {
                        "*": function(t) {
                            for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                e[_key - 1] = arguments[_key];
                            }
                            return _this.trigger.apply(_this, [
                                "Carousel.".concat(t)
                            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e)));
                        },
                        init: function(t) {
                            return _this.Carousel = t;
                        },
                        createSlide: this.onCreateSlide,
                        settle: this.onSettle
                    }
                }, this.option("Carousel"))), this.option("dragToClose") && this.Carousel.Panzoom.on({
                    touchMove: this.onTouchMove,
                    afterTransform: this.onTransform,
                    touchEnd: this.onTouchEnd
                }), this.trigger("initCarousel"), this;
            }
        },
        {
            key: "onCreateSlide",
            value: function onCreateSlide(t, e) {
                var i = e.caption || "";
                if ("function" == typeof this.options.caption && (i = this.options.caption.call(this, this, this.Carousel, e)), "string" == typeof i && i.length) {
                    var t1 = document.createElement("div"), s = "fancybox__caption_".concat(this.id, "_").concat(e.index);
                    t1.className = "fancybox__caption", t1.innerHTML = i, t1.setAttribute("id", s), e.$caption = e.$el.appendChild(t1), e.$el.classList.add("has-caption"), e.$el.setAttribute("aria-labelledby", s);
                }
            }
        },
        {
            key: "onSettle",
            value: function onSettle() {
                this.option("autoFocus") && this.focus();
            }
        },
        {
            key: "onFocus",
            value: function onFocus(t) {
                this.isTopmost() && this.focus(t);
            }
        },
        {
            key: "onClick",
            value: function onClick(t) {
                if (t.defaultPrevented) return;
                var e = t.composedPath()[0];
                if (e.matches("[data-fancybox-close]")) return t.preventDefault(), void R.close(!1, t);
                if (e.matches("[data-fancybox-next]")) return t.preventDefault(), void R.next();
                if (e.matches("[data-fancybox-prev]")) return t.preventDefault(), void R.prev();
                var i = document.activeElement;
                if (i) {
                    if (i.closest("[contenteditable]")) return;
                    e.matches(x) || i.blur();
                }
                if (e.closest(".fancybox__content")) return;
                if (getSelection().toString().length) return;
                if (!1 === this.trigger("click", t)) return;
                switch(this.option("click")){
                    case "close":
                        this.close();
                        break;
                    case "next":
                        this.next();
                }
            }
        },
        {
            key: "onTouchMove",
            value: function onTouchMove() {
                var t = this.getSlide().Panzoom;
                return !t || 1 === t.content.scale;
            }
        },
        {
            key: "onTouchEnd",
            value: function onTouchEnd(t) {
                var e = t.dragOffset.y;
                Math.abs(e) >= 150 || Math.abs(e) >= 35 && t.dragOffset.time < 350 ? (this.option("hideClass") && (this.getSlide().hideClass = "fancybox-throwOut" + (t.content.y < 0 ? "Up" : "Down")), this.close()) : "y" === t.lockAxis && t.panTo({
                    y: 0
                });
            }
        },
        {
            key: "onTransform",
            value: function onTransform(t) {
                if (this.$backdrop) {
                    var e = Math.abs(t.content.y), i = e < 1 ? "" : Math.max(.33, Math.min(1, 1 - e / t.content.fitHeight * 1.5));
                    this.$container.style.setProperty("--fancybox-ts", i ? "0s" : ""), this.$container.style.setProperty("--fancybox-opacity", i);
                }
            }
        },
        {
            key: "onMousedown",
            value: function onMousedown() {
                "ready" === this.state && document.body.classList.add("is-using-mouse");
            }
        },
        {
            key: "onKeydown",
            value: function onKeydown(t) {
                if (!this.isTopmost()) return;
                document.body.classList.remove("is-using-mouse");
                var e = t.key, i = this.option("keyboard");
                if (!i || t.ctrlKey || t.altKey || t.shiftKey) return;
                var s = t.composedPath()[0], o = document.activeElement && document.activeElement.classList, n = o && o.contains("carousel__button");
                if ("Escape" !== e && !n) {
                    if (t.target.isContentEditable || -1 !== [
                        "BUTTON",
                        "TEXTAREA",
                        "OPTION",
                        "INPUT",
                        "SELECT",
                        "VIDEO"
                    ].indexOf(s.nodeName)) return;
                }
                if (!1 === this.trigger("keydown", e, t)) return;
                var a = i[e];
                "function" == typeof this[a] && this[a]();
            }
        },
        {
            key: "getSlide",
            value: function getSlide() {
                var t = this.Carousel;
                if (!t) return null;
                var e = null === t.page ? t.option("initialPage") : t.page, i = t.pages || [];
                return i.length && i[e] ? i[e].slides[0] : null;
            }
        },
        {
            key: "focus",
            value: function focus(t) {
                if (R.ignoreFocusChange) return;
                if ([
                    "init",
                    "closing",
                    "customClosing",
                    "destroy"
                ].indexOf(this.state) > -1) return;
                var e = this.$container, i = this.getSlide(), s = "done" === i.state ? i.$el : null;
                if (s && s.contains(document.activeElement)) return;
                t && t.preventDefault(), R.ignoreFocusChange = !0;
                var o = Array.from(e.querySelectorAll(x));
                var n, a = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t = _step.value;
                        var e1 = _$t.offsetParent, i1 = s && s.contains(_$t), o1 = !this.Carousel.$viewport.contains(_$t);
                        e1 && (i1 || o1) ? (a.push(_$t), void 0 !== _$t.dataset.origTabindex && (_$t.tabIndex = _$t.dataset.origTabindex, _$t.removeAttribute("data-orig-tabindex")), (_$t.hasAttribute("autoFocus") || !n && i1 && !_$t.classList.contains("carousel__button")) && (n = _$t)) : (_$t.dataset.origTabindex = void 0 === _$t.dataset.origTabindex ? _$t.getAttribute("tabindex") : _$t.dataset.origTabindex, _$t.tabIndex = -1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                t ? a.indexOf(t.target) > -1 ? this.lastFocus = t.target : this.lastFocus === e ? w(a[a.length - 1]) : w(e) : this.option("autoFocus") && n ? w(n) : a.indexOf(document.activeElement) < 0 && w(e), this.lastFocus = document.activeElement, R.ignoreFocusChange = !1;
            }
        },
        {
            key: "hideScrollbar",
            value: function hideScrollbar() {
                if (!v) return;
                var t = window.innerWidth - document.documentElement.getBoundingClientRect().width, e = "fancybox-style-noscroll";
                var i = document.getElementById(e);
                i || t > 0 && (i = document.createElement("style"), i.id = e, i.type = "text/css", i.innerHTML = ".compensate-for-scrollbar {padding-right: ".concat(t, "px;}"), document.getElementsByTagName("head")[0].appendChild(i), document.body.classList.add("compensate-for-scrollbar"));
            }
        },
        {
            key: "revealScrollbar",
            value: function revealScrollbar() {
                document.body.classList.remove("compensate-for-scrollbar");
                var t = document.getElementById("fancybox-style-noscroll");
                t && t.remove();
            }
        },
        {
            key: "clearContent",
            value: function clearContent(t) {
                this.Carousel.trigger("removeSlide", t), t.$content && (t.$content.remove(), t.$content = null), t.$closeButton && (t.$closeButton.remove(), t.$closeButton = null), t._className && t.$el.classList.remove(t._className);
            }
        },
        {
            key: "setContent",
            value: function setContent(t, e) {
                var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var s;
                var o = t.$el;
                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, HTMLElement)) [
                    "img",
                    "iframe",
                    "video",
                    "audio"
                ].indexOf(e.nodeName.toLowerCase()) > -1 ? (s = document.createElement("div"), s.appendChild(e)) : s = e;
                else {
                    var _$t = document.createRange().createContextualFragment(e);
                    s = document.createElement("div"), s.appendChild(_$t);
                }
                if (t.filter && !t.error && (s = s.querySelector(t.filter)), (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(s, Element)) return t._className = "has-".concat(i.suffix || t.type || "unknown"), o.classList.add(t._className), s.classList.add("fancybox__content"), "none" !== s.style.display && "none" !== getComputedStyle(s).getPropertyValue("display") || (s.style.display = t.display || this.option("defaultDisplay") || "flex"), t.id && s.setAttribute("id", t.id), t.$content = s, o.prepend(s), this.manageCloseButton(t), "loading" !== t.state && this.revealContent(t), s;
                this.setError(t, "{{ELEMENT_NOT_FOUND}}");
            }
        },
        {
            key: "manageCloseButton",
            value: function manageCloseButton(t) {
                var _this = this;
                var e = void 0 === t.closeButton ? this.option("closeButton") : t.closeButton;
                if (!e || "top" === e && this.$closeButton) return;
                var i = document.createElement("button");
                i.classList.add("carousel__button", "is-close"), i.setAttribute("title", this.options.l10n.CLOSE), i.innerHTML = this.option("template.closeButton"), i.addEventListener("click", function(t) {
                    return _this.close(t);
                }), "inside" === e ? (t.$closeButton && t.$closeButton.remove(), t.$closeButton = t.$content.appendChild(i)) : this.$closeButton = this.$container.insertBefore(i, this.$container.firstChild);
            }
        },
        {
            key: "revealContent",
            value: function revealContent(t) {
                var _this = this;
                this.trigger("reveal", t), t.$content.style.visibility = "";
                var e = !1;
                t.error || "loading" === t.state || null !== this.Carousel.prevPage || t.index !== this.options.startIndex || (e = void 0 === t.showClass ? this.option("showClass") : t.showClass), e ? (t.state = "animating", this.animateCSS(t.$content, e, function() {
                    _this.done(t);
                })) : this.done(t);
            }
        },
        {
            key: "animateCSS",
            value: function animateCSS(t, e, i) {
                if (t && t.dispatchEvent(new CustomEvent("animationend", {
                    bubbles: !0,
                    cancelable: !0
                })), !t || !e) return void ("function" == typeof i && i());
                var s = function(o) {
                    o.currentTarget === this && (t.removeEventListener("animationend", s), i && i(), t.classList.remove(e));
                };
                t.addEventListener("animationend", s), t.classList.add(e);
            }
        },
        {
            key: "done",
            value: function done(t) {
                t.state = "done", this.trigger("done", t);
                var e = this.getSlide();
                e && t.index === e.index && this.option("autoFocus") && this.focus();
            }
        },
        {
            key: "setError",
            value: function setError(t, e) {
                t.error = e, this.hideLoading(t), this.clearContent(t);
                var i = document.createElement("div");
                i.classList.add("fancybox-error"), i.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, i, {
                    suffix: "error"
                });
            }
        },
        {
            key: "showLoading",
            value: function showLoading(t) {
                var _this = this;
                t.state = "loading", t.$el.classList.add("is-loading");
                var e = t.$el.querySelector(".fancybox__spinner");
                e || (e = document.createElement("div"), e.classList.add("fancybox__spinner"), e.innerHTML = this.option("template.spinner"), e.addEventListener("click", function() {
                    _this.Carousel.Panzoom.velocity || _this.close();
                }), t.$el.prepend(e));
            }
        },
        {
            key: "hideLoading",
            value: function hideLoading(t) {
                var e = t.$el && t.$el.querySelector(".fancybox__spinner");
                e && (e.remove(), t.$el.classList.remove("is-loading")), "loading" === t.state && (this.trigger("load", t), t.state = "ready");
            }
        },
        {
            key: "next",
            value: function next() {
                var t = this.Carousel;
                t && t.pages.length > 1 && t.slideNext();
            }
        },
        {
            key: "prev",
            value: function prev() {
                var t = this.Carousel;
                t && t.pages.length > 1 && t.slidePrev();
            }
        },
        {
            key: "jumpTo",
            value: function jumpTo() {
                for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
                    t[_key] = arguments[_key];
                }
                var _Carousel;
                this.Carousel && (_Carousel = this.Carousel).slideTo.apply(_Carousel, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(t));
            }
        },
        {
            key: "isClosing",
            value: function isClosing() {
                return [
                    "closing",
                    "customClosing",
                    "destroy"
                ].includes(this.state);
            }
        },
        {
            key: "isTopmost",
            value: function isTopmost() {
                return R.getInstance().id == this.id;
            }
        },
        {
            key: "close",
            value: function close(t) {
                var _this = this;
                if (t && t.preventDefault(), this.isClosing()) return;
                if (!1 === this.trigger("shouldClose", t)) return;
                if (this.state = "closing", this.Carousel.Panzoom.destroy(), this.detachEvents(), this.trigger("closing", t), "destroy" === this.state) return;
                this.$container.setAttribute("aria-hidden", "true"), this.$container.classList.add("is-closing");
                var e = this.getSlide();
                if (this.Carousel.slides.forEach(function(t) {
                    t.$content && t.index !== e.index && _this.Carousel.trigger("removeSlide", t);
                }), "closing" === this.state) {
                    var _$t = void 0 === e.hideClass ? this.option("hideClass") : e.hideClass;
                    this.animateCSS(e.$content, _$t, function() {
                        _this.destroy();
                    }, !0);
                }
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if ("destroy" === this.state) return;
                this.state = "destroy", this.trigger("destroy");
                var t = this.option("placeFocusBack") ? this.option("triggerTarget", this.getSlide().$trigger) : null;
                this.Carousel.destroy(), this.detachPlugins(), this.Carousel = null, this.options = {}, this.events = {}, this.$container.remove(), this.$container = this.$backdrop = this.$carousel = null, t && w(t), I.delete(this.id);
                var e = R.getInstance();
                e ? e.focus() : (document.documentElement.classList.remove("with-fancybox"), document.body.classList.remove("is-using-mouse"), this.revealScrollbar());
            }
        }
    ], [
        {
            key: "show",
            value: function show(t) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return new R(t, e);
            }
        },
        {
            key: "fromEvent",
            value: function fromEvent(t) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (t.defaultPrevented) return;
                if (t.button && 0 !== t.button) return;
                if (t.ctrlKey || t.metaKey || t.shiftKey) return;
                var i = t.composedPath()[0];
                var s, o, n, a = i;
                if ((a.matches("[data-fancybox-trigger]") || (a = a.closest("[data-fancybox-trigger]"))) && (e.triggerTarget = a, s = a && a.dataset && a.dataset.fancyboxTrigger), s) {
                    var _$t = document.querySelectorAll('[data-fancybox="'.concat(s, '"]')), e1 = parseInt(a.dataset.fancyboxIndex, 10) || 0;
                    a = _$t.length ? _$t[e1] : a;
                }
                Array.from(R.openers.keys()).reverse().some(function(e) {
                    n = a || i;
                    var s = !1;
                    try {
                        (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(n, Element) && ("string" == typeof e || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, String)) && (s = n.matches(e) || (n = n.closest(e)));
                    } catch (t1) {}
                    return !!s && (t.preventDefault(), o = e, !0);
                });
                var r = !1;
                if (o) {
                    e.event = t, e.target = n, n.origTarget = i, r = R.fromOpener(o, e);
                    var s1 = R.getInstance();
                    s1 && "ready" === s1.state && t.detail && document.body.classList.add("is-using-mouse");
                }
                return r;
            }
        },
        {
            key: "fromOpener",
            value: function fromOpener(t) {
                var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var s = [], o = i.startIndex || 0, n = i.target || null;
                var a = void 0 !== (i = e({}, i, R.openers.get(t))).groupAll && i.groupAll, r = void 0 === i.groupAttr ? "data-fancybox" : i.groupAttr, h = r && n ? n.getAttribute("".concat(r)) : "";
                if (!n || h || a) {
                    var e1 = i.root || (n ? n.getRootNode() : document.body);
                    s = [].slice.call(e1.querySelectorAll(t));
                }
                if (n && !a && (s = h ? s.filter(function(t) {
                    return t.getAttribute("".concat(r)) === h;
                }) : [
                    n
                ]), !s.length) return !1;
                var _$l = R.getInstance();
                return !(_$l && s.indexOf(_$l.options.$trigger) > -1) && (o = n ? s.indexOf(n) : o, s = s.map(function(t) {
                    var e = [
                        "false",
                        "0",
                        "no",
                        "null",
                        "undefined"
                    ], i = [
                        "true",
                        "1",
                        "yes"
                    ], s = Object.assign({}, t.dataset), o = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(s)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_step.value, 2), _$t = _value[0], n = _value[1];
                            if ("fancybox" !== _$t) if ("width" === _$t || "height" === _$t) o["_".concat(_$t)] = n;
                            else if ("string" == typeof n || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(n, String)) if (e.indexOf(n) > -1) o[_$t] = !1;
                            else if (i.indexOf(o[_$t]) > -1) o[_$t] = !0;
                            else try {
                                o[_$t] = JSON.parse(n);
                            } catch (e1) {
                                o[_$t] = n;
                            }
                            else o[_$t] = n;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, Element) && (o.$trigger = t), o;
                }), new R(s, e({}, i, {
                    startIndex: o,
                    $trigger: n
                })));
            }
        },
        {
            key: "bind",
            value: function bind(t) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var i = function i() {
                    document.body.addEventListener("click", R.fromEvent, !1);
                };
                v && (R.openers.size || (/complete|interactive|loaded/.test(document.readyState) ? i() : document.addEventListener("DOMContentLoaded", i)), R.openers.set(t, e));
            }
        },
        {
            key: "unbind",
            value: function unbind(t) {
                R.openers.delete(t), R.openers.size || R.destroy();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var t;
                for(; t = R.getInstance();)t.destroy();
                R.openers = new Map, document.body.removeEventListener("click", R.fromEvent, !1);
            }
        },
        {
            key: "getInstance",
            value: function getInstance(t) {
                if (t) return I.get(t);
                return Array.from(I.values()).reverse().find(function(t) {
                    return !t.isClosing() && t;
                }) || null;
            }
        },
        {
            key: "close",
            value: function close() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, e = arguments.length > 1 ? arguments[1] : void 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (t) try {
                    for(var _iterator = I.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t1 = _step.value;
                        t1.close(e);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else {
                    var t2 = R.getInstance();
                    t2 && t2.close(e);
                }
            }
        },
        {
            key: "next",
            value: function next() {
                var t = R.getInstance();
                t && t.next();
            }
        },
        {
            key: "prev",
            value: function prev() {
                var t = R.getInstance();
                t && t.prev();
            }
        }
    ]);
    return R;
}(l);
R.version = "4.0.31", R.defaults = M, R.openers = new Map, R.Plugins = O, R.bind("[data-fancybox]");
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = Object.entries(R.Plugins || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_step.value, 2), t1 = _value[0], e1 = _value[1];
        "function" == typeof e1.create && e1.create(R);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}



/***/ })

}]);